// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* mapCenterStyles.css */

.map-center-page,
.map-center-page * {
  box-sizing: border-box;
}

.map-center-page .map-center-root {
  min-width: 0;
}

@media (max-width: 1199px) {
  body.map-center-responsive-page #root {
    margin-left: 0 !important;
    overflow-x: hidden;
  }

  body.map-center-responsive-page .sidenav---sidenav---_2tBP {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 12000;
    width: 0;
    min-width: 0;
    overflow: hidden;
    transform: translateX(-100%);
    transition: width .2s ease, transform .2s ease;
  }

  body.map-center-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {
    width: min(280px, 86vw);
    min-width: min(280px, 86vw);
    overflow-y: auto;
    transform: translateX(0);
    box-shadow: 8px 0 24px rgba(15, 39, 60, .22);
  }

  .map-center-page #layout-navbar {
    min-height: 64px;
    padding: 4px 12px 4px 8px;
  }

  .map-center-page #layout-navbar .app-brand-link {
    display: flex;
    flex: 1 1 auto;
    min-width: 0;
    align-items: center;
    justify-content: flex-start;
    margin-right: 0;
    overflow: hidden;
  }

  .map-center-page #layout-navbar .trafico-mobile-menu-toggle {
    display: inline-flex;
    flex: 0 0 44px;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    margin-right: 8px;
    padding: 0;
    border: 0;
    border-radius: 10px;
    background: transparent;
    color: #006699;
    font-size: 25px;
    cursor: pointer;
  }

  .map-center-page #layout-navbar .app-brand-link img {
    display: block;
    width: min(190px, 100%);
    max-width: 100%;
    height: 54px !important;
    object-fit: contain;
    object-position: left center;
  }

  .map-center-page #layout-navbar .navbar-nav-right {
    position: static;
    flex: 0 0 auto;
    min-width: 0;
  }

  .map-center-page #layout-navbar .navbar-actions {
    gap: 4px;
  }

  .map-center-page #layout-navbar .nav-notify,
  .map-center-page #layout-navbar .nav-avatar {
    flex: 0 0 auto;
  }

  .map-center-page #layout-navbar .notification-icon {
    font-size: 26px;
  }

  .map-center-page #layout-navbar .notificationsCount {
    min-width: 24px;
    height: 20px;
    padding: 1px 5px;
    font-size: 11px;
    line-height: 18px;
  }

  .map-center-page #layout-navbar .avatar-img {
    width: 40px;
    height: 40px;
  }

  .map-center-page .map-center-root .map-container {
    min-height: calc(100vh - 128px);
    max-height: calc(100vh - 128px);
  }
}

@media (max-width: 767px) {
  .map-center-page #layout-navbar {
    min-height: 60px;
    padding: 4px 8px;
  }

  .map-center-page #layout-navbar .app-brand-link img {
    width: min(172px, 100%);
    height: 48px !important;
    object-fit: contain;
    object-position: left center;
  }

  .map-center-page #layout-navbar .notification-icon {
    font-size: 24px;
  }

  .map-center-page #layout-navbar .avatar-img {
    width: 38px;
    height: 38px;
  }

  .map-center-page .map-center-root .map-container {
    min-height: calc(100vh - 124px);
    max-height: calc(100vh - 124px);
  }
}

/* 0) Wrapper global */
.map-center-root .map-container {
  position: relative;
  width: 100%;
  height: 90vh;
  overflow: hidden;
  z-index: 999 !important;
}

.tour-first p {
  margin: 0 0 10px;
}

.tour-skip-btn {
  background: transparent;
  border: 1px solid #006699;
  color: #006699;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 0.85rem;
  cursor: pointer;
}

.tour-skip-btn:hover {
  background: rgba(0, 102, 153, 0.08);
}

.map-center-root.has-bottom-grid .map-container {
  height: 70vh;
}

.map-center-root .bottom-device-grid {
  width: 100%;
  padding: 8px 12px 12px;
  background: #f7f9fb;
  border-top: 1px solid #d8e1e8;
  display: flex;
  flex-direction: column;
}

.map-center-root .bottom-device-grid__inner {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(260px, 1fr);
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 6px;
  height: 100%;
  align-content: start;
}

.map-center-root .bottom-device-card {
  min-width: 260px;
}

.map-center-root .bottom-device-table {
  width: 100%;
  padding: 8px 12px 12px;
  background: #f7f9fb;
  border-top: 1px solid #d8e1e8;
  display: flex;
  flex-direction: column;
}

.map-center-root .bottom-device-table__inner {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  height: 100%;
}

.map-center-root .bottom-device-table__table {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  background: #fff;
}

.map-center-root .bottom-device-table__table th,
.map-center-root .bottom-device-table__table td {
  padding: 2px 6px;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
  font-size: 0.85rem;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.2;
  text-align: start;
}

.map-center-root .bottom-device-table__table thead th {
  position: sticky;
  top: 0;
  background: #006699;
  color: #fff;
  font-weight: 700;
}

.map-center-root .bottom-device-table__table tbody tr:hover {
  background: #f2f7fb;
  cursor: pointer;
}

.map-center-root .bottom-device-table__table tbody tr.is-selected {
  background: #c8d7e4;
  font-weight: 800;  
}



.map-center-root .bottom-resize-handle {
  height: 8px;
  cursor: row-resize;
  background: linear-gradient(180deg, #dbe6ef 0%, #c9d7e2 100%);
  border-top: 1px solid #b9c9d6;
  border-bottom: 1px solid #b9c9d6;
}

.map-center-root .bottom-resize-handle:hover {
  background: linear-gradient(180deg, #cfddea 0%, #bacbd8 100%);
}

.map-center-root .bottom-device-table__icons {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  align-items: center;
}

.map-center-root .map-fullscreen-control {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1201;
}

.map-center-root .map-fullscreen-button {
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  padding: 0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #ddd;
  color: #1f2933;
  box-sizing: border-box;
}

.map-center-root .geocercas-place-search {
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
  width: 100%;
  min-height: 54px;
  display: flex;
  align-items: center;
  gap: 11px;
  box-sizing: border-box;
  padding: 0 12px 0 18px;
  border: 1px solid rgba(15, 76, 129, 0.15);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 16px 30px rgba(7, 53, 79, 0.16);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.map-center-root .geocercas-place-search:focus-within {
  border-color: rgba(26, 160, 216, 0.58);
  box-shadow: 0 20px 40px rgba(7, 53, 79, 0.2), 0 0 0 3px rgba(26, 160, 216, 0.13);
}

.map-center-root .geocercas-place-search__icon {
  flex: 0 0 auto;
  color: #0f4c81;
  font-size: 17px;
}

.map-center-root .geocercas-place-search__input {
  flex: 1 1 auto;
  min-width: 0;
  height: 50px;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #16324a;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
}

.map-center-root .geocercas-place-search__input::placeholder {
  color: #8296a8;
  font-weight: 500;
  opacity: 1;
}

.map-center-root .geocercas-place-search__input::-webkit-search-cancel-button {
  display: none;
}

.map-center-root .geocercas-place-search__clear {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  padding: 0 0 2px;
  border: 0;
  border-radius: 11px;
  background: linear-gradient(135deg, rgba(15, 76, 129, 0.1), rgba(26, 160, 216, 0.16));
  color: #0f4c81;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.map-center-root .geocercas-place-search__clear:hover {
  background: linear-gradient(135deg, rgba(15, 76, 129, 0.17), rgba(26, 160, 216, 0.24));
}

.map-center-root .mapcenter-place-search-shell {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: min(520px, calc(100vw - 180px));
  z-index: 1202;
  pointer-events: none;
}

.map-center-root .mapcenter-place-search-shell.with-fast-filters {
  top: 86px;
}

.map-center-root .mapcenter-place-search {
  width: 100%;
  min-height: 58px;
  pointer-events: auto;
}

/* Google inserta las sugerencias fuera del contenedor de React. */
.pac-container {
  z-index: 100000 !important;
  margin-top: 7px;
  overflow: hidden;
  border: 1px solid rgba(15, 76, 129, 0.13);
  border-radius: 16px;
  box-shadow: 0 20px 42px rgba(7, 53, 79, 0.2);
  font-family: inherit;
}

.pac-item {
  padding: 9px 14px;
  border-top-color: rgba(15, 76, 129, 0.08);
  color: #5d7489;
  cursor: pointer;
}

.pac-item:hover,
.pac-item-selected {
  background: #eef7fc;
}

.pac-item-query {
  color: #16324a;
  font-size: 13px;
}

@media (max-width: 767px) {
  .map-center-root .geocercas-place-search {
    width: 100%;
    min-height: 52px;
    padding-left: 16px;
    border-radius: 16px;
  }

  .map-center-root .mapcenter-place-search-shell {
    top: 72px;
    width: calc(100vw - 104px);
  }

  .map-center-root .mapcenter-place-search-shell.with-fast-filters {
    top: 146px;
  }
}

.map-center-root .map-fullscreen-button:hover {
  background: #f0f5f9;
}

.map-center-root .map-fullscreen-button.active {
  background: #006699;
  border-color: #006699;
  color: #fff;
}

.map-center-root .map-cargotronics-logo {
  position: absolute;
  top: 4px;
  right: 64px;
  width: 180px;
  height: 64px;
  object-fit: contain;
  pointer-events: none;
  z-index: 1302;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.map-center-root.is-fullscreen .map-cargotronics-logo {
  opacity: 0.55;
  pointer-events: auto;
}

.map-center-root.is-fullscreen .map-cargotronics-logo:hover {
  opacity: 1;
}

body.map-center-fullscreen #layout-navbar,
body.map-center-fullscreen .layout-navbar,
body.map-center-fullscreen .sidenav---sidenav---_2tBP {
  display: none !important;
}

body.map-center-fullscreen .map-center-root .map-actions-stack .action-item .fast-info-button,
.map-center-root.is-fullscreen .map-actions-stack .action-item .fast-info-button {
  display: none !important;
}

body.map-center-fullscreen .layout-page {
  padding-top: 0 !important;
}


.map-center-root .badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.map-center-root .icon-refuerzo {
  font-size: 1.5rem;
  font-weight: bold;
  color: #dc3545;
}

.badge-refuerzo {
  color: #fff;
  background-color: #17a2b8 !important;
}

.map-center-root .badge-danger {
  color: #1a1717 !important;
  background-color: #dc3545 !important;
}


/* ----------------------------------
   3) Fila de alertas (íconos) sobre el mapa
   ---------------------------------- */
.map-center-root .alerts-row {
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 1rem;
  z-index: 22;
  /* Por encima de controles y botón */
}

.map-center-root .alert-icon {
  position: relative;
  width: 48px;
  height: 48px;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: transform 0.15s;
}

.map-center-root .alert-icon:hover {
  transform: translateY(-2px);
}

.map-center-root .alert-icon.active {
  background-color: #dfdddd;
  box-shadow: 0px 4px 6px #006699,
    0px 8px 15px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.map-center-root .map-live-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #e11d48;
  box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.7);
  animation: map-live-pulse 1.2s ease-out infinite;
}

@keyframes map-live-pulse {
  0% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 8px rgba(225, 29, 72, 0);
  }
  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(225, 29, 72, 0);
  }
}

.map-center-root .fast-filters-button {
  position: absolute;
  top: 10px;
  right: 57px;
  z-index: 920;
  width: 114px;
  height: 38px;
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.map-center-root .fast-geocerca-button {
  position: absolute;
  top: 56px;
  /* 👈 debajo del botón de filtros */
  right: 57px;
  /* 👈 misma columna que filtros */
  z-index: 1000;
  width: 112px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}

.map-center-root .fast-georutas-button {
  position: absolute;
  top: 102px;
  /* 👈 debajo de geocercas */
  right: 57px;
  /* 👈 misma columna */
  z-index: 1000;
  width: 112px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}

.map-center-root .fast-invias-button {
  position: absolute;
  top: 194px;
  /* debajo de dispositivos */
  right: 57px;
  z-index: 1000;
  width: 112px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}



.map-center-root .fast-filters-button.active::after {
  content: "";
  position: absolute;
  top: -2px;
  /* ajústalo hasta que quede centrado */
  right: -2px;
  /* ajústalo para que no pise el ícono */
  width: 8px;
  height: 8px;
  background: #006699;
  border-radius: 50%;
  animation: pulse 1.5s infinite ease-in-out;
}

.map-center-root .fast-geocerca-button.active::after {
  content: "";
  position: absolute;
  top: -2px;
  /* ajústalo hasta que quede centrado */
  right: -2px;
  /* ajústalo para que no pise el ícono */
  width: 8px;
  height: 8px;
  background: #006699;
  border-radius: 50%;
  animation: pulse 1.5s infinite ease-in-out;
}

.map-center-root .fast-georutas-button.active::after {
  content: "";
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background: #006699;
  border-radius: 50%;
  animation: pulse 1.5s infinite ease-in-out;
}

.map-center-root .fast-invias-button.active::after {
  content: "";
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background: #006699;
  border-radius: 50%;
  animation: pulse 1.5s infinite ease-in-out;
}


.map-center-root .badge {
  position: absolute;
  bottom: -6px;
  right: -6px;
  background-color: #e74c3c;
  color: #fff;
  font-size: 0.75rem;
  padding: 2px 6px;
  border-radius: 12px;
  line-height: 1;
}

/* ----------------------------------
   4) Botón Offcanvas / filtro
   ---------------------------------- */
.map-center-root .sidebar-toggle-btn {
  position: absolute;
  top: 60px;
  /* Ajusta según tu layout */
  right: 10px;
  z-index: 20;
  /* Detrás de Google Maps (21) */
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 4px;
  padding: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  transition: background 0.15s;
}

.map-center-root .sidebar-toggle-btn:hover {
  background: rgba(255, 255, 255, 1);
}

/* ----------------------------------
   5) Controles de Google Maps 
   ---------------------------------- */
.map-center-root .gm-control-active,
.map-center-root .gmnoprint,
.map-center-root .gm-bundled-control {
  z-index: 21;
}

/* ----------------------------------
   6) Contenedor del mapa
   ---------------------------------- */
.map-center-root .map-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.map-center-root #map {
  width: 100%;
  height: 100vh;
}

/* ----------------------------------
   7) Ajustes al Offcanvas (reactstrap)
   ---------------------------------- */



/* no dañes otros offcanvas end */


/* ---------- DEFAULT (desktop) ---------- */
.offcanvas-backdrop.show {
  position: fixed !important;
  top: 0px !important;
  left: 0 !important;
  /* desktop: NO recorta por sidenav */
  right: 0 !important;
  bottom: 0 !important;
  background: rgba(0, 0, 0, 0.25) !important;
  z-index: 2500 !important;
}

.offcanvas.custom-offcanvas-map-center {
  position: fixed !important;
  top: 0px !important;
  bottom: 0 !important;
  height: calc(100vh - 0px) !important;

  right: 0 !important;
  left: auto !important;
  /* desktop: normal */
  margin-left: 0 !important;
  /* desktop: normal */

  width: 380px !important;
  max-width: 100vw !important;
  z-index: 2600 !important;
}


/* ----------------------------------
   8) Dropdown “Dispositivos”
   ---------------------------------- */
.map-center-root .menu-dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 0;
  border-bottom: 1px solid #e0e0e0;
}

.map-center-root .device-item {
  padding: 0.4rem 0;
  cursor: pointer;
  transition: background 0.15s;
}

.map-center-root .device-item:hover {
  background-color: #f8f9fa;
}

/* ----------------------------------
   9) Tarjetas de dispositivos
   ---------------------------------- */
.map-center-root .device-card {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  display: flex;
  align-items: start;
  justify-content: start;
}

.map-center-root .device-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
}

.map-center-root .device-cards {
  max-height: 65vh;
  overflow-y: auto;
}

/* Offcanvas custom */
.map-center-root .offcanvas.custom-offcanvas-map-center {
  width: 380px !important;
  max-width: 90%;
  z-index: 2601 !important;
}

/* Menú derecho desplegable */
.map-center-root .right-dropdown-menu {
  position: absolute;
  top: 6.8rem;
  right: 1rem;
  width: 300px;
  /* min-height: 420px; */
  /* background: #fff; */
  /* border: 1px solid #ddd; */
  border-radius: 4px;
  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2); */
  z-index: 1002;
}

.map-center-root .left-dropdown-menu {
  position: absolute;
  top: calc(70px + 38px + 10px) !important;
  /* ajusta a tu gusto */
  left: 12px;
  /* ✅ a la izquierda */
  right: auto;
  width: 300px;
  /* o el ancho que usabas */
  z-index: 1000;
}

/* El tab de colapsar debe “pegar” abajo del panel */
.map-center-root .devices-toggle-tab.devices-toggle-tab--left {
  position: sticky;
  /* o relative si ya lo manejas así */
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 910 !important;
}

.map-center-root .left-dropdown-menu .menu-item {
  padding: 0.6rem 1rem;
  cursor: pointer;
}

.map-center-root .right-dropdown-menu .menu-item {
  padding: 0.6rem 1rem;
  cursor: pointer;
}

.map-center-root .right-dropdown-menu .menu-item:hover {
  background: #f5f5f5;
}

.map-center-root .left-dropdown-menu .menu-item:hover {
  background: #f5f5f5;
}

/* Contenedor de dispositivos */
.right-dropdown-menu .device-cards {
  overflow-y: auto;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE/Edge legacy */
}

.left-dropdown-menu .device-cards {
  overflow-y: auto;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE/Edge legacy */
}

.right-dropdown-menu .device-cards::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.left-dropdown-menu .device-cards::-webkit-scrollbar {
  width: 0;
  height: 0;
}


/* ----------------------------------
   10) InfoWindow HTML interno
   ---------------------------------- */
.info-window-selected-container,
.info-window-selected-body {
  height: auto !important;
  max-height: none !important;
  overflow-y: visible !important;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.info-window-selected-container {
  padding: 0 !important;
  border-radius: 26px !important;
}

.info-window-selected-body {
  display: flex;
  justify-content: center;
  width: 100% !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  box-sizing: border-box;
}

.info-window-selected-container::-webkit-scrollbar,
.info-window-selected-body::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.info-window-selected {
  display: flex;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
  box-sizing: border-box;
  background: #ffffff;
}

.info-window-selected > .info-window-card {
  margin-right: auto;
  margin-left: auto;
  background: #ffffff;
  border: 0 !important;
  top: 0 !important;
}

.info-window-selected .info-window-content {
  margin-top: 0 !important;
}

.map-center-root .info-window-card {
  --iw-primary: #0f6ea8;
  --iw-accent: #1ca3ec;
  --iw-ink: #14324a;
  --iw-muted: #6f8597;
  --iw-surface: #ffffff;
  --iw-bg: #ffffff;
  --iw-border: #d8e6f5;
  --iw-shadow: 0 18px 40px rgba(15, 57, 95, 0.12);
  width: min(620px, calc(100vw - 56px));
  max-width: calc(100vw - 56px);
  top: 20px;
  font-family: "Segoe UI", sans-serif;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: var(--iw-shadow);
  position: relative;
  z-index: 12010;
  background: var(--iw-bg);
  border: 1px solid var(--iw-border);
}

.mobile-detail-offcanvas .offcanvas-header {
  align-items: flex-start;
  background:
    radial-gradient(circle at top right, rgba(28, 163, 236, 0.18), transparent 28%),
    linear-gradient(135deg, #f4f8fc 0%, #ecf3fb 55%, #f9fbff 100%);
  color: #fff;
  border-bottom: 1px solid #d8e6f5;
  padding: 18px 18px 14px;
  box-shadow: 0 10px 24px rgba(15, 57, 95, 0.1);
}

.mobile-detail-offcanvas .offcanvas-header .btn-close {
  opacity: 0.85;
}

.mobile-detail-offcanvas__header {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-right: 8px;
}

.mobile-detail-offcanvas__eyebrow {
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 1;
  color: #5f7a90;
  text-shadow: none;
}

.mobile-detail-offcanvas__header strong {
  font-size: 1.45rem;
  line-height: 1.05;
  letter-spacing: 0.01em;
  color: #14324a;
  text-shadow: none;
}

.mobile-detail-offcanvas__body {
  padding: 0 !important;
  background: linear-gradient(180deg, #f4f8fc 0%, #eef5fc 24%, #f9fbff 100%);
}

.mobile-detail-offcanvas .info-window-card {
  width: 100%;
  max-width: none;
  min-height: 100%;
  border-radius: 0;
  box-shadow: none;
  background: transparent;
}

.mobile-detail-offcanvas .info-window-content {
  width: 100%;
  padding: 14px 16px 20px;
  box-sizing: border-box;
}

.mobile-detail-offcanvas .info-window-topbar {
  display: none !important;
}

.mobile-detail-offcanvas .info-window-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  padding: 0 0 4px;
}

.mobile-detail-offcanvas .info-window-summary__chip {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(11, 83, 125, 0.12);
  border-radius: 16px;
  padding: 12px 10px;
  box-shadow: 0 10px 20px rgba(15, 53, 83, 0.08);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mobile-detail-offcanvas .info-window-summary__label {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #4f6478;
}

.mobile-detail-offcanvas .info-window-summary__chip strong {
  color: #082c46;
  font-size: 0.92rem;
  line-height: 1.2;
}

.mobile-detail-offcanvas .info-window-section {
  margin: 14px 0 0;
  border-radius: 20px;
}

.map-center-root .info-window-topbar {
  display: none;
}

.map-center-root .info-window-content,
.mobile-detail-offcanvas .info-window-content {
  width: 100%;
  max-width: 100%;
  padding: 8px 10px 10px;
  box-sizing: border-box;
  overflow-x: hidden;
}

.map-center-root .info-window-summary,
.mobile-detail-offcanvas .info-window-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-bottom: 7px;
}

.map-center-root .info-window-summary__chip,
.mobile-detail-offcanvas .info-window-summary__chip {
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid #dbe8f6;
  border-radius: 12px;
  padding: 6px 8px;
  box-shadow: 0 10px 24px rgba(15, 57, 95, 0.08);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.map-center-root .info-window-summary__label,
.mobile-detail-offcanvas .info-window-summary__label {
  font-size: 0.6rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--iw-muted);
}

.map-center-root .info-window-summary__chip strong,
.mobile-detail-offcanvas .info-window-summary__chip strong {
  color: var(--iw-ink);
  font-size: 0.82rem;
  line-height: 1.15;
}

.map-center-root .info-window-kicker {
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #5f7a90;
  text-shadow: none;
}

.map-center-root .info-window-close-btn {
  width: 38px;
  height: 38px;
  border: 1px solid #cfe7fb;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: var(--iw-primary);
  flex: none;
}

.map-center-root .info-window-close-btn:hover {
  background: #f2f9ff;
}

.map-center-root .info-window-header,
.mobile-detail-offcanvas .info-window-header {
  padding: 0.48rem 0.75rem;
  font-weight: 700;
  border-radius: 16px 16px 0 0;
  margin: 0;
  color: #ffffff !important;
  background: linear-gradient(135deg, var(--iw-primary, #0f6ea8), var(--iw-accent, #1ca3ec));
  font-size: 0.8rem;
  letter-spacing: 0.01em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.28);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18);
}

.map-center-root .info-window-header,
.mobile-detail-offcanvas .info-window-header {
  color: #ffffff !important;
}

.map-center-root .info-window-body {
  padding: 0.2rem 0.7rem 0.35rem;
  background: transparent;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 14px;
}

.map-center-root .info-window-section,
.mobile-detail-offcanvas .info-window-section {
  margin-top: 7px;
  border-radius: 14px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid #dbe8f6;
  box-shadow: 0 12px 28px rgba(15, 57, 95, 0.08);
}

.map-center-root .info-window-section--contract .info-window-header,
.mobile-detail-offcanvas .info-window-section--contract .info-window-header {
  background: linear-gradient(135deg, #0d5f93 0%, #1782c2 100%);
}

.map-center-root .info-window-section--driver .info-window-header,
.mobile-detail-offcanvas .info-window-section--driver .info-window-header {
  background: linear-gradient(135deg, #0b567f 0%, #1270ab 100%);
}

.map-center-root .info-row,
.mobile-detail-offcanvas .info-row {
  display: grid;
  grid-template-columns: minmax(120px, 42%) minmax(0, 1fr);
  align-items: flex-start;
  column-gap: 8px;
  row-gap: 3px;
  margin-bottom: 0;
  padding: 0.3rem 0;
  border-bottom: 1px solid #e4edf7;
}

.map-center-root .info-row:last-child,
.mobile-detail-offcanvas .info-row:last-child {
  border-bottom: 0;
  padding-bottom: 0.1rem;
}

.map-center-root .info-label,
.mobile-detail-offcanvas .info-label {
  color: #446983;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.map-center-root .info-value,
.mobile-detail-offcanvas .info-value {
  font-weight: 800;
  color: var(--iw-ink);
  text-align: start;
  min-width: 0;
  overflow-wrap: anywhere;
  display: block;
  font-size: 0.8rem;
  line-height: 1.2;
}

.map-center-root .info-window-action-btn,
.mobile-detail-offcanvas .info-window-action-btn {
  font-size: 0.72rem;
  font-weight: 700;
  min-width: 104px;
  min-height: 36px;
  margin: 0 !important;
  border-radius: 11px;
  border-width: 1px;
  background: #fff;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33.333% - 10px);
  width: auto;
  max-width: 100%;
  padding: 0 10px;
  box-shadow: 0 8px 18px rgba(16, 52, 79, 0.06);
  border-style: solid;
  border-color: #d4dde6;
  text-align: center;
  line-height: 1.15;
  white-space: normal;
  box-sizing: border-box;
}

.map-center-root .info-window-actions,
.mobile-detail-offcanvas .info-window-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 6px;
  padding: 0.4rem 0.55rem 0.5rem;
  background: transparent;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.map-center-root .info-window-actions {
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 8px;
}

.map-center-root .info-window-action-btn {
  min-width: 0;
  flex: 1 1;
  padding: 0 10px;
  font-size: 0.8rem;
}

.map-center-root .info-window-actions::-webkit-scrollbar,
.mobile-detail-offcanvas .info-window-actions::-webkit-scrollbar {
  display: none;
}

.map-center-root .info-window-action-btn--primary,
.mobile-detail-offcanvas .info-window-action-btn--primary {
  color: #ffffff;
  border-color: transparent;
  background: linear-gradient(135deg, var(--iw-primary), var(--iw-accent));
  box-shadow: 0 10px 24px rgba(24, 119, 179, 0.22);
}

.map-center-root .info-window-action-btn--neutral,
.mobile-detail-offcanvas .info-window-action-btn--neutral {
  color: #165c8a;
  border-color: #9cc8eb;
}

.map-center-root .info-window-action-btn--info,
.mobile-detail-offcanvas .info-window-action-btn--info {
  color: #165c8a;
  border-color: #9cc8eb;
}

.map-center-root .info-window-action-btn--danger,
.mobile-detail-offcanvas .info-window-action-btn--danger {
  color: #d63b3b;
  border-color: #f4b9b9;
}

.map-center-root .info-window-action-btn--success,
.mobile-detail-offcanvas .info-window-action-btn--success {
  color: #2d9c2d;
  border-color: #bfe8b7;
}

.map-center-root .info-window-live-btn,
.mobile-detail-offcanvas .info-window-live-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.map-center-root .info-window-live-dot,
.mobile-detail-offcanvas .info-window-live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #dc3545;
  box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
  animation: info-window-pulse 1.2s ease-out infinite;
  flex: none;
}

@keyframes info-window-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
  }
  100% {
    box-shadow: 0 0 0 8px rgba(220, 53, 69, 0);
  }
}

@media (max-width: 768px) {
  body.mobile-detail-offcanvas-open .offcanvas-backdrop.show {
    left: 0 !important;
    width: 100vw !important;
    z-index: 2999 !important;
  }

  .offcanvas.mobile-detail-offcanvas {
    inset: 0 !important;
    width: 100vw !important;
    max-width: 100vw !important;
    height: 100dvh !important;
    left: 0 !important;
    right: 0 !important;
    margin-left: 0 !important;
    z-index: 3000 !important;
  }

  .info-window-mobile-shell {
    position: fixed !important;
    inset: 0 !important;
    width: 100vw !important;
    height: 100dvh !important;
    z-index: 20000 !important;
    pointer-events: auto !important;
  }

  .info-window-mobile-shell > div {
    inset: 0 !important;
  }

  .info-window-mobile-shell .gm-style-iw-c {
    padding: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .info-window-mobile-shell .gm-style-iw-t,
  .info-window-mobile-shell .gm-style-iw-tc,
  .info-window-mobile-shell .gm-style-iw-chr {
    display: none !important;
  }

  .info-window-mobile-body {
    max-height: 100dvh !important;
    overflow: hidden !important;
    padding: 0 !important;
  }

  .map-center-root .info-window-card {
    width: 100vw;
    max-width: 100vw;
    min-height: 100dvh;
    border-radius: 0;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    background: linear-gradient(180deg, #f4f8fc 0%, #eef5fc 24%, #f9fbff 100%);
  }

  .mobile-detail-offcanvas .info-window-card {
    width: 100%;
    max-width: 100%;
    min-height: auto;
    display: block;
    background: transparent;
  }

  .mobile-detail-offcanvas .info-window-content {
    padding: 14px 14px 24px;
  }

  .mobile-detail-offcanvas .info-window-summary {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 10px;
  }

  .mobile-detail-offcanvas .info-window-summary__chip {
    padding: 10px 10px 9px;
    border-radius: 14px;
  }

  .mobile-detail-offcanvas .info-window-summary__label {
    font-size: 0.6rem;
    letter-spacing: 0.07em;
  }

  .mobile-detail-offcanvas .info-window-summary__chip strong {
    font-size: 0.9rem;
    line-height: 1.2;
  }

  .map-center-root .info-window-topbar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: max(16px, env(safe-area-inset-top)) 16px 14px;
    color: #14324a;
    position: sticky;
    top: 0;
    z-index: 2;
    background: linear-gradient(135deg, #f4f8fc 0%, #ecf3fb 55%, #f9fbff 100%);
    border-bottom: 1px solid #d8e6f5;
    box-shadow: 0 10px 24px rgba(15, 57, 95, 0.08);
  }

  .map-center-root .info-window-topbar-copy {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .map-center-root .info-window-header {
    padding: 0.88rem 1rem;
    font-size: 0.95rem;
  }

  .mobile-detail-offcanvas .info-window-header {
    padding: 0.78rem 0.9rem;
    font-size: 0.86rem;
    letter-spacing: 0.01em;
  }

  .map-center-root .info-window-body {
    padding: 0.35rem 0.9rem 0.8rem;
  }

  .mobile-detail-offcanvas .info-window-body {
    padding: 0.25rem 0.85rem 0.65rem;
  }

  .map-center-root .info-window-body,
  .mobile-detail-offcanvas .info-window-body {
    grid-template-columns: minmax(0, 1fr);
  }

  .map-center-root .info-window-summary,
  .mobile-detail-offcanvas .info-window-summary {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .map-center-root .info-row,
  .mobile-detail-offcanvas .info-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 14px;
    margin-bottom: 0;
    padding: 0.8rem 0;
  }

  .mobile-detail-offcanvas .info-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 6px;
    padding: 0.72rem 0;
    align-items: start;
  }

  .map-center-root .info-label,
  .mobile-detail-offcanvas .info-label,
  .map-center-root .info-value,
  .mobile-detail-offcanvas .info-value {
    width: auto;
    flex: 0 1 auto;
    font-size: 0.96rem;
  }

  .map-center-root .info-label,
  .mobile-detail-offcanvas .info-label {
    color: #446983;
    max-width: 45%;
    padding-right: 8px;
  }

  .mobile-detail-offcanvas .info-label {
    max-width: none;
    padding-right: 0;
    font-size: 0.72rem;
    letter-spacing: 0.06em;
    line-height: 1.25;
  }

  .map-center-root .info-value,
  .mobile-detail-offcanvas .info-value {
    text-align: right;
    color: #14324a;
    max-width: 55%;
  }

  .mobile-detail-offcanvas .info-value {
    max-width: none;
    text-align: left;
    font-size: 0.98rem;
    line-height: 1.32;
  }

  .map-center-root .info-window-section,
  .mobile-detail-offcanvas .info-window-section {
    margin-top: 12px;
    border-radius: 18px;
  }

  .mobile-detail-offcanvas .info-window-section {
    border-radius: 16px;
    box-shadow: 0 12px 24px rgba(15, 53, 83, 0.07);
  }

  .map-center-root .info-window-actions,
  .mobile-detail-offcanvas .info-window-actions {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr);
    align-items: stretch;
    justify-content: stretch;
    gap: 10px !important;
    padding: 0.9rem 0 calc(20px + env(safe-area-inset-bottom));
    margin-top: 14px;
    background: linear-gradient(180deg, rgba(248, 251, 253, 0) 0%, #f8fbfd 18%, #f8fbfd 100%);
    position: sticky;
    bottom: 0;
    width: 100%;
    overflow: visible;
  }

  .map-center-root .info-window-action-btn,
  .mobile-detail-offcanvas .info-window-action-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-width: 0;
    min-height: 46px;
    border-radius: 12px;
    padding: 10px 12px;
    margin: 0 !important;
    background: #fff;
  }

  .mobile-detail-offcanvas .info-window-action-btn--primary {
    color: #ffffff !important;
    border-color: transparent !important;
    background: linear-gradient(135deg, #0f6ea8, #1ca3ec) !important;
  }

  .mobile-detail-offcanvas .info-window-actions {
    position: static;
    margin-top: 0;
    background: transparent;
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
  }

  .mobile-detail-offcanvas__eyebrow {
    font-size: 0.66rem;
    letter-spacing: 0.08em;
    color: #5f7a90;
  }

  .mobile-detail-offcanvas__header strong {
    font-size: 1.2rem;
    line-height: 1.08;
    color: #14324a;
  }
}

/* ----------------------------------
   11) Input + botón filtro
   ---------------------------------- */
.map-center-root .search-filter-container {
  position: absolute;
  top: 3.8rem;
  left: 12px;
  right: auto !important;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  z-index: 1002;
}

/* el buscador y botón quedan arriba del panel izquierdo */




.map-center-root .search-input {
  width: 255px;
  height: 38px;
  padding: 0 8px;
  font-size: 0.9rem;
  flex: none;
  box-sizing: border-box;
}

.map-center-root .filter-btn {
  width: 38px;
  height: 38px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
}

.map-center-root .filter-btn svg {
  width: 18px;
  height: 18px;
}

.map-center-root .notification-badge {
  position: absolute;
  top: -5px;
  /* Ajusta la posición del badge */
  right: -5px;
  /* Ajusta la posición del badge */
  width: 15px;
  /* Tamaño del badge */
  height: 15px;
  /* Tamaño del badge */
  background-color: #006699;
  /* Color del badge */
  border-radius: 50%;
  /* Hace que sea un círculo */
  animation: pulse 1.5s infinite;
  /* Hace que palpite */
  border: 2px solid white;
  /* Opcional: agrega un borde blanco */
}

/* Darageable infromacion adicional izq */
.rnd-draggable {
  cursor: move;
}


/* Centrar el icono del HtmlMarker */
.map-center-root .marker-icon {
  position: absolute;
  width: 28px;
  height: 28px;
  /* sitúa el punto (0,0) del div en la coordenada: */
  left: 50%;
  top: 0;
  /* desplaza el div: -50% ancho (centrado horizontal) y -100% alto 
     para que la base del icono quede clavada en la coordenada */
  transform: translate(-50%, -100%);
  cursor: pointer;
  pointer-events: none;
}

.map-center-root .marker-plate-wrap {
  position: relative;
  width: 40px;
  height: 40px;
  overflow: visible;
}

.map-center-root .hover-marker-info-button {
  position: absolute;
  top: auto;
  right: auto;
  bottom: -45px;
  left: calc(50% + 15px);
  z-index: 3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  color: #ffffff;
  font: 700 16px/1 "Segoe UI", sans-serif;
  background: #0f6ea8;
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(15, 57, 95, 0.3);
  cursor: pointer;
  transition:
    background-color 0.18s ease,
    box-shadow 0.18s ease,
    transform 0.18s ease;
}

.map-center-root .hover-marker-info-button:hover,
.map-center-root .hover-marker-info-button:focus-visible {
  color: #ffffff;
  background: #1ca3ec;
  box-shadow: 0 5px 13px rgba(15, 57, 95, 0.38);
  outline: none;
  transform: scale(1.08);
}

.map-center-root .marker-plate-badge {
  position: absolute;
  left: 50%;
  top: -3px;
  transform: translate(-50%, -100%);
  min-width: 104px;
  max-width: 160px;
  padding: 5px 9px;
  border-radius: 10px;
  background: rgba(7, 48, 79, 0.92);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.92);
  box-shadow: 0 4px 10px rgba(6, 28, 47, 0.22);
  font-size: 10px;
  font-weight: 800;
  line-height: 1.25;
  text-align: center;
  pointer-events: none;
}

.map-center-root .marker-plate-badge__plate,
.map-center-root .marker-plate-badge__line {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.map-center-root .marker-plate-badge__plate {
  font-size: 11px;
  letter-spacing: 0.04em;
}

.map-center-root .marker-plate-badge__line {
  margin-top: 2px;
  color: rgba(255, 255, 255, 0.88);
  font-size: 9px;
  font-weight: 600;
}

.map-center-root .marker-hover-anchor {
  position: relative;
  width: 40px;
  height: 40px;
  overflow: visible;
  transform: translate(-50%, -100%) !important;
  outline: none;
  cursor: pointer !important;
  z-index: 20;
}

.map-center-root .marker-hover-anchor:hover,
.map-center-root .marker-hover-anchor:focus-visible {
  cursor: pointer !important;
}

.map-center-root .marker-hover-anchor .marker-icon {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer !important;
}

.map-center-root .marker-hover-anchor.is-hover-active {
  z-index: 1400;
}

.map-center-root .info-window-hover {
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(-50%, calc(-100% - 32px)) scale(0.98);
  min-width: 220px;
  max-width: 300px;
  display: block;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
  z-index: 1300;
  overflow: visible;
}

.map-center-root .info-window-hover::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -60px;
  width: 110px;
  height: 60px;
  transform: translateX(-50%);
}

.map-center-root .info-window-hover.is-visible {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
  transform: translate(-50%, calc(-100% - 42px)) scale(1);
}

.map-center-root .info-window-hover.is-hiding {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transform: translate(-50%, calc(-100% - 26px)) scale(0.985);
}

.map-center-root .info-window-hover-card {
  position: relative;
  border-radius: 14px;
  padding: 12px 14px;
  background: rgba(255, 255, 255, 0.98);
  color: #284057;
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.2);
  border: 1px solid rgba(0, 102, 153, 0.14);
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.map-center-root .info-window-hover-card::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -8px;
  width: 16px;
  height: 16px;
  background: rgba(255, 255, 255, 0.98);
  border-right: 1px solid rgba(0, 102, 153, 0.14);
  border-bottom: 1px solid rgba(0, 102, 153, 0.14);
  transform: translateX(-50%) rotate(45deg);
}

.map-center-root .info-window-hover-title {
  margin-bottom: 8px;
  color: #0f3554;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}

.map-center-root .info-window-hover-grid {
  display: grid;
  gap: 4px;
  font-size: 13px;
  line-height: 1.4;
  color: #4b6175;
}

.map-center-root .info-window-hover-grid strong {
  color: #16324a;
}




/* ----------------------------------
   12) Grid de iconos en el panel de seguimiento
   ---------------------------------- */
/* grid y estilos básicos */
/* contenedor general del panel de seguimiento */
.map-center-root .icon-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 16px;
  background: transparent;
  /* un fondo muy suave */
  border-radius: 12px;
  transform: translate(-8px, 0px);
}

/* cada “casilla” de icono */
.map-center-root .icon-grid .icon-item {
  width: 48px;
  height: 48px;
  background: #FFFFFF;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  object-fit: contain;
  filter: grayscale(100%);
  opacity: 0.6;
  padding: 8px;
  /* sombra más profunda y extendida */
  box-shadow:
    0 4px 8px rgba(0, 0, 0, 0.1),
    0 12px 24px rgba(0, 0, 0, 0.15);
  transition: filter 0.3s, opacity 0.3s, transform 0.3s, box-shadow 0.3s;
}

.map-center-root .icon-grid .icon-item.active {
  filter: none;
  opacity: 1;
  /* al activarse, sube un poco la sombra */
  box-shadow:
    0 6px 12px rgba(0, 0, 0, 0.15),
    0 16px 32px rgba(0, 0, 0, 0.2);
}

/* íconos que cambiaron (pulso infinito) */
.map-center-root .icon-grid .icon-item.icon-changed {
  animation: pulse 1s ease-in-out infinite alternate;
}

/* Botones */
.custom-offcanvas-map-center .buttonPrimary {
  background-color: #006699 !important;
  color: #fff !important;
  border: none !important;
  padding: 10px 20px !important;
  border-radius: 5px !important;
  cursor: pointer !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.custom-offcanvas-map-center .buttonSecondary {
  background-color: #e0e0e0 !important;
  color: #333 !important;
  border: none !important;
  padding: 10px 20px !important;
  border-radius: 5px !important;
  cursor: pointer !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}


.custom-offcanvas-map-center .buttonPrimary:hover {
  background-color: #00557a;
}

.custom-offcanvas-map-center .buttonSecondary:hover {
  background-color: #d5d5d5;
}

.custom-offcanvas-map-center button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.custom-offcanvas-map-center .geo-actions {
  display: flex;
  justify-content: center;
  /* ✅ centrado desktop */
  gap: 10px;
  margin-top: 12px;
  flex-wrap: wrap;
  /* ✅ permite salto a segunda fila */
}

/* Botones map actions*/

/* =========================================================
   Stack pegado al botón de fullscreen (Google Maps)
   - no mueve a los otros botones
   - solo el hovered se expande (overlay)
   ========================================================= */

/* 1) Stack cerca del fullscreen (esquina superior derecha) */
.map-center-root .map-actions-stack {
  position: absolute;
  top: 60px;
  right: 10px;
  /* pegado al borde; si choca, sube a 14/16 */
  z-index: 1200;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* 2) Cada fila reserva un slot fijo (no se mueve nada) */
.map-center-root .map-actions-stack .action-item {
  position: relative;
  width: 40px;
  height: 40px;
}

/* 3) El botón vive ABSOLUTO dentro del slot para expandirse sin empujar */
.map-center-root .map-actions-stack .action-item .fast-filters-button,
.map-center-root .map-actions-stack .action-item .fast-geocerca-button,
.map-center-root .map-actions-stack .action-item .fast-georutas-button,
.map-center-root .map-actions-stack .action-item .fast-invias-button,
.map-center-root .map-actions-stack .action-item .fast-placa-button,
.map-center-root .map-actions-stack .action-item .fast-info-button,
.map-center-root .map-actions-stack .action-item .fast-live-button {
  position: absolute !important;
  top: 0;
  right: 0;
  /* anclado a la derecha */
  height: 40px !important;
  width: 20px !important;
  min-width: 28px !important;

  overflow: hidden !important;
  border-radius: 10px !important;

  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;

  padding: 0 12px !important;
  background: #fff;
  border: 1px solid #ddd;

  transition: width .18s ease, background .18s ease, border-color .18s ease;
}

/* 4) Texto oculto dentro del mismo botón */
.map-center-root .map-actions-stack .action-item .fast-filters-button span,
.map-center-root .map-actions-stack .action-item .fast-geocerca-button span,
.map-center-root .map-actions-stack .action-item .fast-georutas-button span,
.map-center-root .map-actions-stack .action-item .fast-invias-button span,
.map-center-root .map-actions-stack .action-item .fast-placa-button span,
.map-center-root .map-actions-stack .action-item .fast-info-button span,
.map-center-root .map-actions-stack .action-item .fast-live-button span {
  display: inline-block !important;
  opacity: 0;
  transform: translateX(-6px);
  max-width: 0;
  overflow: hidden;
  white-space: nowrap;
  pointer-events: none;

  font-size: 12px;
  font-weight: 700;
  color: #003a55;

  transition: opacity .18s ease, transform .18s ease, max-width .18s ease;
}

.map-center-root .map-actions-stack .action-item .fast-devices-button {
  position: absolute !important;
  top: 0;
  right: 0;
  height: 40px !important;
  width: 20px !important;
  min-width: 28px !important;
  overflow: hidden !important;
  border-radius: 10px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  padding: 0 12px !important;
  background: #fff;
  color: #2e3a47;
  border: 1px solid #ddd;
  transition: width .18s ease, background .18s ease, border-color .18s ease;
}

.map-center-root .map-actions-stack .action-item .fast-devices-button span {
  display: inline-block !important;
  opacity: 0;
  transform: translateX(-6px);
  max-width: 0;
  overflow: hidden;
  white-space: nowrap;
  pointer-events: none;
  font-size: 12px;
  font-weight: 700;
  color: #003a55;
  transition: opacity .18s ease, transform .18s ease, max-width .18s ease;
}

.map-center-root .map-actions-stack .action-item .fast-filters-button svg,
.map-center-root .map-actions-stack .action-item .fast-geocerca-button svg,
.map-center-root .map-actions-stack .action-item .fast-georutas-button svg,
.map-center-root .map-actions-stack .action-item .fast-invias-button svg,
.map-center-root .map-actions-stack .action-item .fast-placa-button svg,
.map-center-root .map-actions-stack .action-item .fast-devices-button svg,
.map-center-root .map-actions-stack .action-item .fast-info-button svg,
.map-center-root .map-actions-stack .action-item .fast-live-button svg {
  flex-shrink: 0;
}

.map-center-root .map-actions-stack .action-item .fast-live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #dc3545;
  box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
  animation: info-window-pulse 1.2s ease-out infinite;
  flex: none;
}

.map-center-root .map-actions-stack .action-item:hover .fast-devices-button,
.map-center-root .map-actions-stack .action-item:focus-within .fast-devices-button {
  width: 160px !important;
  justify-content: flex-start !important;
  border-color: rgba(0, 102, 153, .35);
  background: rgba(255, 255, 255, .95);
}

.map-center-root .map-actions-stack .action-item:hover .fast-devices-button span,
.map-center-root .map-actions-stack .action-item:focus-within .fast-devices-button span {
  opacity: 1;
  transform: translateX(0);
  max-width: 120px;
}

.map-center-root .map-actions-stack .action-item .fast-devices-button.active {
  background: #006699;
  border-color: #006699;
  color: #fff;
}

.map-center-root .map-actions-stack .action-item .fast-devices-button.active span {
  color: #fff;
}

/* 5) SOLO el hovered se expande hacia la izquierda (overlay) */
.map-center-root .map-actions-stack .action-item:hover .fast-filters-button,
.map-center-root .map-actions-stack .action-item:hover .fast-geocerca-button,
.map-center-root .map-actions-stack .action-item:hover .fast-georutas-button,
.map-center-root .map-actions-stack .action-item:hover .fast-invias-button,
.map-center-root .map-actions-stack .action-item:hover .fast-placa-button,
.map-center-root .map-actions-stack .action-item:hover .fast-info-button,
.map-center-root .map-actions-stack .action-item:hover .fast-live-button,
.map-center-root .map-actions-stack .action-item:focus-within .fast-filters-button,
.map-center-root .map-actions-stack .action-item:focus-within .fast-geocerca-button,
.map-center-root .map-actions-stack .action-item:focus-within .fast-georutas-button,
.map-center-root .map-actions-stack .action-item:focus-within .fast-invias-button,
.map-center-root .map-actions-stack .action-item:focus-within .fast-placa-button,
.map-center-root .map-actions-stack .action-item:focus-within .fast-info-button,
.map-center-root .map-actions-stack .action-item:focus-within .fast-live-button {
  width: 160px !important;
  /* ancho del pill */
  justify-content: flex-start !important;
  border-color: rgba(0, 102, 153, .35);
  background: rgba(255, 255, 255, .95);
  color: #2e3a47 !important;
}

/* 6) Mostrar texto del hovered */
.map-center-root .map-actions-stack .action-item:hover .fast-filters-button span,
.map-center-root .map-actions-stack .action-item:hover .fast-geocerca-button span,
.map-center-root .map-actions-stack .action-item:hover .fast-georutas-button span,
.map-center-root .map-actions-stack .action-item:hover .fast-invias-button span,
.map-center-root .map-actions-stack .action-item:hover .fast-placa-button span,
.map-center-root .map-actions-stack .action-item:hover .fast-info-button span,
.map-center-root .map-actions-stack .action-item:hover .fast-live-button span,
.map-center-root .map-actions-stack .action-item:focus-within .fast-filters-button span,
.map-center-root .map-actions-stack .action-item:focus-within .fast-geocerca-button span,
.map-center-root .map-actions-stack .action-item:focus-within .fast-georutas-button span,
.map-center-root .map-actions-stack .action-item:focus-within .fast-invias-button span,
.map-center-root .map-actions-stack .action-item:focus-within .fast-placa-button span,
.map-center-root .map-actions-stack .action-item:focus-within .fast-info-button span,
.map-center-root .map-actions-stack .action-item:focus-within .fast-live-button span {
  opacity: 1;
  transform: translateX(0);
  max-width: 120px;
}

/* 7) Active */
.map-center-root .map-actions-stack .action-item .fast-filters-button.active,
.map-center-root .map-actions-stack .action-item .fast-geocerca-button.active,
.map-center-root .map-actions-stack .action-item .fast-georutas-button.active,
.map-center-root .map-actions-stack .action-item .fast-invias-button.active,
.map-center-root .map-actions-stack .action-item .fast-placa-button.active,
.map-center-root .map-actions-stack .action-item .fast-info-button.active,
.map-center-root .map-actions-stack .action-item .fast-live-button.active {
  background: #006699;
  border-color: #006699;
  color: #fff;
}

.map-center-root .map-actions-stack .action-item .fast-filters-button.active span,
.map-center-root .map-actions-stack .action-item .fast-geocerca-button.active span,
.map-center-root .map-actions-stack .action-item .fast-georutas-button.active span,
.map-center-root .map-actions-stack .action-item .fast-invias-button.active span,
.map-center-root .map-actions-stack .action-item .fast-placa-button.active span,
.map-center-root .map-actions-stack .action-item .fast-info-button.active span,
.map-center-root .map-actions-stack .action-item .fast-live-button.active span {
  color: #fff;
}







.map-center-root .map-actions-stack .action-btn {
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #2e3a47;
  border: 1px solid #ddd;
}

.map-center-root .map-actions-stack .action-btn.active {
  background: #006699;
  color: #fff;
  border-color: #006699;
}

.map-center-root .map-actions-stack .action-btn:hover {
  background: #e9f2f8;
}



/* Colapsa la lista */
.right-dropdown-menu .device-cards.is-collapsed {
  display: none;
  min-height: auto;
}

.left-dropdown-menu .device-cards.is-collapsed {
  display: none;
  min-height: 5px;
}

/* Pestaña tipo acordeón (flecha) */
.right-dropdown-menu {
  position: relative;
  /* para posicionar la pestaña dentro */
}

.left-dropdown-menu {
  position: relative;
  /* para posicionar la pestaña dentro */
}

/* Tab translucida */
.devices-toggle-tab {
  position: sticky;
  /* se queda abajo aunque scrollees */
  bottom: 0;
  width: 140px;
  height: 34px;
  border: 0;
  cursor: pointer;
  margin: 0 auto;
  border-radius: 12px 12px 0 0;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  background: rgba(0, 102, 153, 0.22);
  /* translúcido */
  backdrop-filter: blur(6px);
  /* glass effect */
  -webkit-backdrop-filter: blur(6px);

  color: #003a55;
  transition: background .15s ease, transform .15s ease, opacity .15s ease;
  opacity: .65;
}

/* Hover: más visible y clickeable */
.devices-toggle-tab:hover {
  background: rgba(0, 102, 153, 0.45);
  opacity: 1;
}

/* Flecha grande */
.devices-toggle-tab .tab-arrow {
  font-size: 18px;
  line-height: 1;
  font-weight: 700;
  color: #003a55;
}

/* Cuando está cerrado, muestro contador al lado */
.devices-toggle-tab .tab-count {
  min-width: 28px;
  height: 20px;
  padding: 0 8px;
  border-radius: 999px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  font-size: 12px;
  font-weight: 700;

  background: rgba(255, 255, 255, .8);
  color: #003a55;
  border: 1px solid rgba(0, 58, 85, .25);
}

/* Pequeño “feedback” visual según estado */
.devices-toggle-tab.is-open .tab-arrow {
  transform: translateY(1px);
}

.devices-toggle-tab.is-closed .tab-arrow {
  transform: translateY(-1px);
}



/* keyframes del pulso */
@keyframes pulse {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(1.15);
  }
}

/* Cards de dispositivos con la misma jerarquia visual en desktop y responsive. */
.map-center-root .device-card.device-card--responsive {
  width: 100% !important;
  margin-bottom: 10px !important;
  border: 1px solid rgba(110, 144, 176, 0.16) !important;
  border-left: 5px solid var(--device-status-color) !important;
  border-radius: 0 16px 16px 0 !important;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 7px 18px rgba(17, 48, 79, 0.14);
  overflow: hidden;
  transform: none;
}

.map-center-root .device-card.device-card--responsive:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(17, 48, 79, 0.2);
}

.map-center-root .device-card__body {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 220px;
  padding: 12px 12px 10px !important;
  color: #4d6984;
}

.map-center-root .device-card__header {
  position: relative;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: center;
  gap: 7px;
  min-width: 0;
  min-height: 38px;
  padding-right: 26px;
}

.map-center-root .device-card__vehicle-icon {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: rgba(22, 119, 210, 0.12);
  color: var(--device-status-color);
  font-size: 18px;
}

.map-center-root .device-card__heading {
  min-width: 0;
}

.map-center-root .device-card__company {
  overflow: hidden;
  color: #152b47;
  font-size: 0.82rem;
  font-weight: 800;
  line-height: 1.15;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.map-center-root .device-card__identity {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
}

.map-center-root .device-card__pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  padding: 5px 7px;
  overflow: hidden;
  border-radius: 999px;
  background: #eef4fa;
  color: #526c86;
  font-size: 0.62rem;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.map-center-root .device-card__pill svg {
  flex: 0 0 auto;
  color: #4d6984;
}

.map-center-root .device-card__chevron,
.map-center-root .device-card__more {
  color: #58738e;
  font-size: 0.85rem;
}

.map-center-root .device-card__chevron {
  position: absolute;
  top: 1px;
  right: -4px;
  font-size: 1.35rem;
}

.map-center-root .device-card__more {
  font-size: 0.95rem;
}

.map-center-root .device-card__location {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-top: 11px;
  min-height: 2.6em;
  color: #516c87;
  font-size: 0.72rem;
  line-height: 1.3;
}

.map-center-root .device-card__location > span {
  min-width: 0;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.map-center-root .device-card__location svg {
  flex: 0 0 auto;
  margin-top: 1px;
  color: #536f8b;
  font-size: 0.95rem;
}

.map-center-root .device-card__location strong {
  color: #304c68;
  font-weight: 800;
}

.map-center-root .device-card__device-location {
  min-height: 1.3em;
}

.map-center-root .device-card__metrics {
  display: flex;
  flex-wrap: nowrap;
  gap: 14px;
  margin-top: 8px;
  min-height: 18px;
  padding-left: 0;
  color: #536f8b;
  font-size: 0.72rem;
}

.map-center-root .device-card__metrics span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-weight: 700;
}

.map-center-root .device-card__metrics span:last-child {
  color: #536f8b;
}

.map-center-root .device-card__metrics svg {
  font-size: 0.9rem;
}

.map-center-root .device-card__footer {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto 48px;
  align-items: center;
  gap: 6px;
  min-height: 32px;
  margin-top: auto;
  padding-top: 9px;
  border-top: 1px solid #e2eaf1;
}

.map-center-root .device-card__status-icons {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.map-center-root .device-card__status-icons img {
  width: 19px;
  height: 19px;
  object-fit: contain;
}

.map-center-root .device-card__state {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 8px;
  min-width: 88px;
  justify-content: center;
  border-radius: 999px;
  font-size: 0.64rem;
  font-weight: 800;
  white-space: nowrap;
}

.map-center-root .device-card__state-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}

.map-center-root .device-card__state--moving {
  color: #129447;
  background: #def8e9;
}

.map-center-root .device-card__state--stopped {
  color: #e5233b;
  background: #ffe1e6;
}

.map-center-root .device-card__state--review {
  color: #1677d2;
  background: #dceeff;
}

.map-center-root .device-card__time {
  width: 48px;
  text-align: right;
  color: #71869b;
  font-size: 0.65rem;
  font-weight: 700;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .offcanvas-backdrop.show {
    left: 0 !important;
    width: 100vw !important;
    right: 0 !important;
    z-index: 2999 !important;
  }

  .offcanvas.custom-offcanvas-map-center {
    left: 0 !important;
    right: 0 !important;
    margin-left: 0 !important;
    width: 100vw !important;
    max-width: 100vw !important;
    z-index: 3000 !important;
  }

  .map-center-root .alerts-row {
    /* posición */
    width: 300px;
    height: 120px;
    top: 110px;
    /* debajo de tus botones */
    right: 20px;
    left: auto;
    transform: none;

    /* 2 filas fijas */
    display: grid !important;
    grid-auto-flow: column;
    /* llena columnas y baja a la fila 2 */
    grid-template-rows: repeat(2, auto);
    grid-auto-columns: max-content;

    gap: 8px;
    align-items: center;
    justify-content: center;

    /* que NO se meta bajo el sidenav */
    max-width: calc(100vw - 64px - 20px);
    overflow-x: auto;
    /* si hay muchos, scrol horizontal */
    padding-bottom: 2px;

    z-index: 1200;
  }

  .map-center-root .alert-icon {
    width: 40px;
    height: 40px;
    border-radius: 9px;
    position: relative;
  }

  .map-center-root .alert-icon img {
    width: 22px;
    height: 22px;
    object-fit: contain;
  }

  .map-center-root .badge.badge-count {
    font-size: .68rem;
  }

  /* opcional: barra de scroll más discreta (Chrome/Edge) */
  .map-center-root .alerts-row::-webkit-scrollbar {
    height: 6px;
  }

  /* el panel existe, pero el contenido se colapsa */
  .map-center-root .right-dropdown-menu {
    min-height: unset;
    /* quita esos 420px en mobile */
    height: auto;
    overflow: hidden;
  }

  .map-center-root .left-dropdown-menu {
    min-height: unset;
    left: 8px;
    width: min(92vw, 360px);
    /* quita esos 420px en mobile */
    height: 55vh;
    overflow: hidden;
  }

  .map-center-root .left-dropdown-menu.is-collapsed{
    height: auto;
  }





  /* animación del contenedor de cards */
  .map-center-root .device-cards {
    max-height: 520px;
    /* abierto */
    overflow-y: auto;
    transition: max-height 250ms ease, opacity 200ms ease, transform 200ms ease;
    transform-origin: top;
    opacity: 1;
    transform: translateY(0);
    width: 80vw;
  }

  /* estado colapsado: queda solo el botón visible */
  .map-center-root .device-cards.is-collapsed {
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    transform: translateY(-6px);
    pointer-events: none;
    display: none;
  }

  .custom-offcanvas-map-center .geo-actions {
    gap: 8px;
  }

  .custom-offcanvas-map-center .geo-actions>button {
    width: calc(50% - 4px);
    /* ✅ 2 por fila */
    min-width: 140px;
    /* opcional */
  }

  /* ================================
   MAP ACTIONS STACK (MOBILE FIXED)
   - NO hover expand
   - NO span
   - NO shift al activar (.active)
   - ancho fijo 40x40
   ================================ */

  /* stack horizontal */
  .map-center-root .map-actions-stack {
    position: absolute;
    top: 10px;
    right: 60px;
    z-index: 1200;

    display: flex;
    flex-direction: row;
    gap: 34px;

    align-items: center;
    justify-content: flex-start;

    max-width: calc(100vw - 120px);
  }

  .map-center-root .map-actions-stack,
  .map-center-root .map-actions-stack *,
  .map-center-root .map-actions-stack *::before,
  .map-center-root .map-actions-stack *::after {
    transition: none !important;
    animation: none !important;
  }

  /* evita cualquier “hover expand” heredado */
  .map-center-root .map-actions-stack .action-item:hover .fast-filters-button,
  .map-center-root .map-actions-stack .action-item:hover .fast-geocerca-button,
  .map-center-root .map-actions-stack .action-item:hover .fast-georutas-button,
  .map-center-root .map-actions-stack .action-item:hover .fast-invias-button,
  .map-center-root .map-actions-stack .action-item:hover .fast-live-button,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-filters-button,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-geocerca-button,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-georutas-button,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-invias-button,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-live-button {
    width: 40px !important;
    justify-content: center !important;
  }

  /* si no quieres el puntico “pulse” en mobile, apágalo */
  .map-center-root .fast-filters-button.active::after,
  .map-center-root .fast-geocerca-button.active::after,
  .map-center-root .fast-georutas-button.active::after,
  .map-center-root .fast-invias-button.active::after,
  .map-center-root .fast-live-button.active::after {
    animation: none !important;
    transform: none !important;
    transition: none !important;
  }

  .map-center-root .map-actions-stack .btn.fast-filters-button span,
  .map-center-root .map-actions-stack .btn.fast-geocerca-button span,
  .map-center-root .map-actions-stack .btn.fast-georutas-button span,
  .map-center-root .map-actions-stack .btn.fast-invias-button span,
  .map-center-root .map-actions-stack .btn.fast-live-button span {
    display: none !important;
  }


  .map-center-root .search-input {
    width: 100%;
    max-width: none;
    height: 54px;
    padding: 0 18px;
    border: 1px solid rgba(112, 145, 177, 0.22);
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.96);
    color: #24415d;
    font-size: 0.98rem;
    box-shadow: 0 10px 24px rgba(18, 52, 82, 0.16);
  }

  .map-center-root .search-input::placeholder {
    color: #8aa0b6;
    opacity: 1;
  }

  .map-center-root .search-filter-container {
    top: 70px;
    left: 14px;
    right: 14px !important;
    gap: 10px;
    z-index: 1203;
  }

  .map-center-root .filter-btn {
    width: 54px;
    height: 54px;
    border: 1px solid rgba(84, 118, 151, 0.35);
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.96);
    color: #294968;
    box-shadow: 0 10px 24px rgba(18, 52, 82, 0.16);
  }

  .map-center-root .filter-btn:hover,
  .map-center-root .filter-btn:focus {
    background: #ffffff;
    color: #0b72bd;
    border-color: #6da7d8;
  }

  .map-center-root .left-dropdown-menu {
    top: 138px !important;
    left: 14px;
    width: min(calc(100vw - 28px), 430px);
    height: calc(100% - 152px);
    max-height: none;
    border-radius: 22px;
    overflow: hidden;
    pointer-events: none;
  }

  .map-center-root .left-dropdown-menu .device-cards,
  .map-center-root .left-dropdown-menu .devices-toggle-tab {
    pointer-events: auto;
  }

  .map-center-root .device-cards {
    width: 100%;
    max-height: 100%;
    padding: 0 0 10px;
  }

  .map-center-root .device-card.device-card--responsive {
    width: 100% !important;
    margin-bottom: 12px !important;
    border: 1px solid rgba(110, 144, 176, 0.14) !important;
    border-left: 6px solid var(--device-status-color) !important;
    border-radius: 0 20px 20px 0 !important;
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 10px 26px rgba(17, 48, 79, 0.17);
    overflow: hidden;
    transform: none;
  }

  .map-center-root .device-card.device-card--responsive:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 30px rgba(17, 48, 79, 0.21);
  }

  .map-center-root .device-card__body {
    min-height: 288px;
    padding: 16px 16px 13px !important;
    color: #4d6984;
  }

  .map-center-root .device-card__header {
    position: relative;
    display: grid;
    grid-template-columns: 52px minmax(0, 1fr);
    align-items: center;
    gap: 10px;
    min-width: 0;
    min-height: 52px;
    padding-right: 30px;
  }

  .map-center-root .device-card__vehicle-icon {
    width: 52px;
    height: 52px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: color-mix(in srgb, var(--device-status-color) 14%, white);
    color: var(--device-status-color);
    font-size: 25px;
  }

  .map-center-root .device-card__heading {
    min-width: 0;
  }

  .map-center-root .device-card__company {
    overflow: hidden;
    color: #152b47;
    font-size: 1.02rem;
    font-weight: 800;
    line-height: 1.15;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .map-center-root .device-card__identity {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
  }

  .map-center-root .device-card__pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 100%;
    padding: 6px 9px;
    overflow: hidden;
    border-radius: 999px;
    background: #eef4fa;
    color: #526c86;
    font-size: 0.75rem;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .map-center-root .device-card__pill svg {
    flex: 0 0 auto;
    color: #4d6984;
  }

  .map-center-root .device-card__chevron,
  .map-center-root .device-card__more {
    color: #58738e;
    font-size: 1rem;
  }

  .map-center-root .device-card__chevron {
    position: absolute;
    top: 1px;
    right: -4px;
    font-size: 1.5rem;
  }

  .map-center-root .device-card__more {
    font-size: 1.05rem;
  }

  .map-center-root .device-card__location {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 15px;
    min-height: 2.7em;
    color: #516c87;
    font-size: 0.86rem;
    line-height: 1.35;
  }

  .map-center-root .device-card__location > span {
    min-width: 0;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .map-center-root .device-card__location svg {
    flex: 0 0 auto;
    margin-top: 2px;
    color: #536f8b;
    font-size: 1.1rem;
  }

  .map-center-root .device-card__location strong {
    color: #304c68;
    font-weight: 800;
  }

  .map-center-root .device-card__device-location {
    min-height: 1.3em;
  }

  .map-center-root .device-card__metrics {
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    margin-top: 11px;
    min-height: 22px;
    padding-left: 0;
    color: #536f8b;
    font-size: 0.87rem;
  }

  .map-center-root .device-card__metrics span {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-weight: 700;
  }

  .map-center-root .device-card__metrics span:last-child {
    color: #536f8b;
  }

  .map-center-root .device-card__metrics svg {
    font-size: 1.06rem;
  }

  .map-center-root .device-card__footer {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto 52px;
    align-items: center;
    gap: 8px;
    min-height: 38px;
    margin-top: auto;
    padding-top: 12px;
    border-top: 1px solid #e2eaf1;
  }

  .map-center-root .device-card__status-icons {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .map-center-root .device-card__status-icons img {
    width: 23px;
    height: 23px;
    object-fit: contain;
  }

  .map-center-root .device-card__state {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 7px 10px;
    min-width: 100px;
    justify-content: center;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 800;
    white-space: nowrap;
  }

  .map-center-root .device-card__state-dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: currentColor;
  }

  .map-center-root .device-card__state--moving {
    color: #129447;
    background: #def8e9;
  }

  .map-center-root .device-card__state--stopped {
    color: #e5233b;
    background: #ffe1e6;
  }

  .map-center-root .device-card__state--review {
    color: #1677d2;
    background: #dceeff;
  }

  .map-center-root .device-card__time {
    width: 52px;
    text-align: right;
    color: #71869b;
    font-size: 0.76rem;
    font-weight: 700;
    white-space: nowrap;
  }
}

/* Devices grid toggle button */
.map-center-root .fast-devices-button {
  position: absolute;
  top: 148px;
  /* debajo de georutas */
  right: 57px;
  z-index: 1000;
  width: 124px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}

.map-center-root .fast-devices-button.active::after {
  content: "";
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background: #006699;
  border-radius: 50%;
  animation: pulse 1.5s infinite ease-in-out;
}

/* Map actions stack rules for devices button */
.map-center-root .map-actions-stack .action-item .fast-devices-button {
  position: absolute !important;
  top: 0;
  right: 0;
  height: 40px !important;
  width: 20px !important;
  min-width: 28px !important;
  overflow: hidden !important;
  border-radius: 10px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  padding: 0 12px !important;
  background: #fff;
  border: 1px solid #ddd;
  transition: width .18s ease, background .18s ease, border-color .18s ease;
}

.map-center-root .map-actions-stack .action-item .fast-devices-button span {
  display: inline-block !important;
  opacity: 0;
  transform: translateX(-6px);
  max-width: 0;
  overflow: hidden;
  white-space: nowrap;
  pointer-events: none;
  font-size: 12px;
  font-weight: 700;
  color: #003a55;
  transition: opacity .18s ease, transform .18s ease, max-width .18s ease;
}

.map-center-root .map-actions-stack .action-item:hover .fast-devices-button,
.map-center-root .map-actions-stack .action-item:focus-within .fast-devices-button {
  width: 160px !important;
  justify-content: flex-start !important;
  border-color: rgba(0, 102, 153, .35);
  background: rgba(255, 255, 255, .95);
}

.map-center-root .map-actions-stack .action-item:hover .fast-devices-button span,
.map-center-root .map-actions-stack .action-item:focus-within .fast-devices-button span {
  opacity: 1;
  transform: translateX(0);
  max-width: 120px;
}

.map-center-root .map-actions-stack .action-item .fast-devices-button.active {
  background: #006699;
  border-color: #006699;
  color: #fff;
}

.map-center-root .map-actions-stack .action-item .fast-devices-button.active span {
  color: #fff;
}

@media (max-width: 768px) {
  .map-center-root .map-actions-stack .action-item:nth-child(-n+3) {
    display: none !important;
  }

  /**
   * Hides the last three action items in the map actions stack
   * 
   * This rule targets the last 3 child elements (counting from the end)
   * within the action-item class and removes them from the document flow
   * by setting their display property to none with high specificity.
   * 
   * Selector breakdown:
   * - .map-center-root: Root container for map-related styles
   * - .map-actions-stack: Container holding action items
   * - .action-item:nth-last-child(-n+3): Matches the last 3 action items
   * 
   * @note !important flag ensures this rule overrides any competing styles
   */
  .map-center-root .map-actions-stack .action-item:nth-child(n+5) {
    display: none !important;
  }

  .map-center-root .map-actions-stack .action-item:hover .fast-devices-button,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-devices-button {
    width: 40px !important;
    justify-content: center !important;
  }

  .map-center-root .fast-devices-button.active::after {
    animation: none !important;
    transform: none !important;
    transition: none !important;
  }

  .map-center-root .map-actions-stack .btn.fast-devices-button span {
    display: none !important;
  }

  .map-center-root .map-fullscreen-control {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .map-center-root .map-actions-dropdown {
    position: relative;
  }

  .map-center-root .map-actions-dropdown-toggle {
    width: 40px;
    height: 40px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .map-center-root .map-actions-dropdown-toggle.is-active {
    background: linear-gradient(135deg, #0f6ea8, #1ca3ec);
    border-color: transparent;
    color: #fff;
    box-shadow: 0 10px 24px rgba(24, 119, 179, 0.22);
  }

  .map-center-root .map-actions-dropdown-menu {
    position: absolute;
    top: 48px;
    right: 0;
    min-width: 200px;
    background: #fff;
    border: 1px solid #dce6f2;
    border-radius: 10px;
    box-shadow: 0 16px 30px rgba(2, 20, 45, 0.15);
    padding: 6px;
    z-index: 1300;
  }

  .map-center-root .map-actions-dropdown-item {
    width: 100%;
    border: 0;
    background: transparent;
    padding: 8px 10px;
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    color: #003a55;
    font-weight: 600;
  }

  .map-center-root .map-actions-dropdown-item.is-active {
    background: #eaf5ff;
    color: #0f6ea8;
    box-shadow: inset 3px 0 0 #1ca3ec;
  }

  .map-center-root .map-actions-dropdown-item:hover,
  .map-center-root .map-actions-dropdown-item:focus {
    background: #f2f7fb;
  }

  .map-center-root .map-actions-dropdown-item-wrap {
    display: flex;
  }

}

/* Estructura estable: el contenido puede truncarse, pero no cambia la geometría de la card. */
.map-center-root .device-card.device-card--responsive {
  height: 195px !important;
  min-height: 195px !important;
  display: block !important;
  width: 100% !important;
}

.map-center-root .device-card.device-card--responsive .device-card__body {
  height: 100%;
  width: 100%;
  min-height: 0 !important;
  overflow: hidden;
}

.map-center-root .device-card__identity {
  flex-wrap: nowrap;
  min-width: 0;
  overflow: hidden;
}

.map-center-root .device-card__identity .device-card__pill {
  min-width: 0;
  flex: 0 1 auto;
  width: fit-content;
  max-width: 100%;
}

.map-center-root .device-card__location {
  flex: 0 0 auto;
}

@media (max-width: 768px) {
  .map-center-root .device-card.device-card--responsive {
    height: 240px !important;
    min-height: 240px !important;
  }
}

/* Controles desktop: tamaño visual de la referencia + expansión original al hacer hover. */
@media (min-width: 769px) {
  .map-center-root .map-actions-stack .action-item {
    width: 40px;
    height: 40px;
  }

  .map-center-root .map-actions-stack .action-item .fast-filters-button,
  .map-center-root .map-actions-stack .action-item .fast-geocerca-button,
  .map-center-root .map-actions-stack .action-item .fast-georutas-button,
  .map-center-root .map-actions-stack .action-item .fast-invias-button,
  .map-center-root .map-actions-stack .action-item .fast-placa-button,
  .map-center-root .map-actions-stack .action-item .fast-devices-button,
  .map-center-root .map-actions-stack .action-item .fast-info-button,
  .map-center-root .map-actions-stack .action-item .fast-live-button {
    width: 40px !important;
    min-width: 40px !important;
    height: 40px !important;
    padding: 4px 0 4px 12px !important;
    border-radius: 8px !important;
    box-shadow: 0 5px 12px rgba(24, 50, 74, 0.12);
  }

  .map-center-root .map-actions-stack .action-item .fast-filters-button svg,
  .map-center-root .map-actions-stack .action-item .fast-geocerca-button svg,
  .map-center-root .map-actions-stack .action-item .fast-georutas-button svg,
  .map-center-root .map-actions-stack .action-item .fast-invias-button svg,
  .map-center-root .map-actions-stack .action-item .fast-placa-button svg,
  .map-center-root .map-actions-stack .action-item .fast-devices-button svg,
  .map-center-root .map-actions-stack .action-item .fast-info-button svg,
  .map-center-root .map-actions-stack .action-item .fast-live-button svg {
    width: 24px;
    height: 24px;
  }

  .map-center-root .map-actions-stack .action-item:hover .fast-filters-button,
  .map-center-root .map-actions-stack .action-item:hover .fast-geocerca-button,
  .map-center-root .map-actions-stack .action-item:hover .fast-georutas-button,
  .map-center-root .map-actions-stack .action-item:hover .fast-invias-button,
  .map-center-root .map-actions-stack .action-item:hover .fast-placa-button,
  .map-center-root .map-actions-stack .action-item:hover .fast-devices-button,
  .map-center-root .map-actions-stack .action-item:hover .fast-info-button,
  .map-center-root .map-actions-stack .action-item:hover .fast-live-button,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-filters-button,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-geocerca-button,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-georutas-button,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-invias-button,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-placa-button,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-devices-button,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-info-button,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-live-button {
    width: 160px !important;
    min-width: 160px !important;
    justify-content: flex-start !important;
  }

  .map-center-root .map-actions-stack .action-item:hover .fast-filters-button span,
  .map-center-root .map-actions-stack .action-item:hover .fast-geocerca-button span,
  .map-center-root .map-actions-stack .action-item:hover .fast-georutas-button span,
  .map-center-root .map-actions-stack .action-item:hover .fast-invias-button span,
  .map-center-root .map-actions-stack .action-item:hover .fast-placa-button span,
  .map-center-root .map-actions-stack .action-item:hover .fast-devices-button span,
  .map-center-root .map-actions-stack .action-item:hover .fast-info-button span,
  .map-center-root .map-actions-stack .action-item:hover .fast-live-button span,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-filters-button span,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-geocerca-button span,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-georutas-button span,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-invias-button span,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-placa-button span,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-devices-button span,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-info-button span,
  .map-center-root .map-actions-stack .action-item:focus-within .fast-live-button span {
    opacity: 1;
    transform: translateX(0);
    max-width: 120px;
  }
}

/* El ID del dispositivo se revela sin cambiar el ancho ni la estructura de la card. */
.map-center-root .device-card__identity {
  overflow: visible;
}

.map-center-root .device-card__pill--device-id {
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.map-center-root .device-card__pill--device-id .device-card__pill-value {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.map-center-root .device-card__pill--device-id::after {
  content: attr(data-value);
  position: absolute;
  top: 50%;
  left: 30px;
  max-width: 0;
  overflow: hidden;
  padding: 0;
  border-radius: 999px;
  background: #eef4fa;
  color: #526c86;
  opacity: 0;
  transform: translateY(-50%);
  white-space: nowrap;
  pointer-events: none;
  transition: max-width 0.35s ease, opacity 0.2s ease, padding 0.35s ease;
}

@media (hover: hover) {
  .map-center-root .device-card__pill--device-id:hover,
  .map-center-root .device-card__pill--device-id:focus-within {
    overflow: visible;
    z-index: 20;
  }

  .map-center-root .device-card__pill--device-id:hover .device-card__pill-value,
  .map-center-root .device-card__pill--device-id:focus-within .device-card__pill-value {
    color: transparent;
  }

  .map-center-root .device-card__pill--device-id:hover::after,
  .map-center-root .device-card__pill--device-id:focus-within::after {
    max-width: 260px;
    padding-right: 10px;
    opacity: 1;
  }
}

/* El ID se desplaza dentro del pill, sin expandirlo ni salir de sus límites. */
.map-center-root .device-card__pill--device-id {
  overflow: hidden !important;
}

.map-center-root .device-card__pill--device-id::after {
  display: none;
}

.map-center-root .device-card__pill--device-id .device-card__pill-value {
  display: inline-block;
  flex: 0 0 auto;
  max-width: none;
  overflow: visible;
  text-overflow: clip;
  color: #526c86;
  white-space: nowrap;
}

@keyframes device-id-pan-inside-pill {
  0%,
  20% {
    transform: translateX(0);
  }

  80%,
  100% {
    transform: translateX(-32%);
  }
}

@media (hover: hover) {
  .map-center-root .device-card__pill--device-id:hover .device-card__pill-value,
  .map-center-root .device-card__pill--device-id:focus-within .device-card__pill-value {
    animation: device-id-pan-inside-pill 3.8s ease-in-out infinite alternate;
    color: #526c86;
  }
}

.map-center-root .device-card__pill-value-viewport {
  display: block;
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  white-space: nowrap;
}

/* Identificadores legibles en las cards de dispositivos, sin aumentar el ancho de la card. */
.map-center-root .device-card__pill {
  padding: 6px 9px;
  font-size: 0.78rem;
  font-weight: 700;
}

.map-center-root .device-card__pill svg {
  font-size: 0.9rem;
}

.map-center-root .bottom-device-card__device,
.map-center-root .bottom-device-card__plate,
.map-center-root .bottom-device-table__device,
.map-center-root .bottom-device-table__plate {
  color: #14324a;
  font-size: 1rem;
  font-weight: 800;
}

.map-center-root .info-window-hover-device {
  font-size: 14px;
  font-weight: 700;
}

@media (max-width: 768px) {
  .map-center-root .device-card__pill {
    padding: 7px 10px;
    font-size: 0.9rem;
  }

  .map-center-root .device-card__pill svg {
    font-size: 1rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Pages/Css/mapCenterStyles.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;;EAEE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,cAAc;IACd,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,8CAA8C;EAChD;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;IAChB,wBAAwB;IACxB,4CAA4C;EAC9C;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,+BAA+B;IAC/B,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,+BAA+B;IAC/B,+BAA+B;EACjC;AACF;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;;;AAIA;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,yCAAyC;EACzC,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;EAC7C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,gFAAgF;AAClF;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,qFAAqF;EACrF,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,sCAAsC;EACtC,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,kEAAkE;AAClE;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;;AAGA;;uCAEuC;AACvC;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB;mCACiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;EACE;IACE,qBAAqB;IACrB,0CAA0C;EAC5C;EACA;IACE,mBAAmB;IACnB,0CAA0C;EAC5C;EACA;IACE,qBAAqB;IACrB,wCAAwC;EAC1C;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mCAAmC;EACnC,WAAW;EACX,iCAAiC;EACjC,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;;;AAIA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,sCAAsC;EACtC,WAAW;EACX,uCAAuC;EACvC,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,sCAAsC;EACtC,WAAW;EACX,uCAAuC;EACvC,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;uCAEuC;AACvC;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;uCAEuC;AACvC;;;EAGE,WAAW;AACb;;AAEA;;uCAEuC;AACvC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;;uCAEuC;;;;AAIvC,iCAAiC;;;AAGjC,4CAA4C;AAC5C;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;;EAEpC,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;;EAEpB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;;AAGA;;uCAEuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;uCAEuC;AACvC;EACE,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,cAAc;EACd,wBAAwB;AAC1B;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,sBAAsB;EACtB,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,aAAa;AACf;;AAEA,oDAAoD;AACpD;EACE,gBAAgB;EAChB,oCAAoC;EACpC,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;;AAGA;;uCAEuC;AACvC;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,+CAA+C;EAC/C,qCAAqC;EACrC,6BAA6B;EAC7B,SAAS;EACT,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB;;kEAEgE;EAChE,WAAW;EACX,gCAAgC;EAChC,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;EACV,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,0EAA0E;AAC5E;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;EACT,yBAAyB;EACzB,0FAA0F;EAC1F,iBAAiB;EACjB,sBAAsB;EACtB,0CAA0C;EAC1C,mDAAmD;AACrD;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;;EAEE,6DAA6D;AAC/D;;AAEA;;EAEE,6DAA6D;AAC/D;;AAEA;;EAEE,aAAa;EACb,wDAAwD;EACxD,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,YAA8B;EAA9B,cAA8B;EAA9B,gCAA8B;EAC9B,WAAW;EACX,eAAe;EACf,eAAe;EACf,6CAA6C;EAC7C,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,QAAQ;EACR,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,SAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,wEAAwE;EACxE,gDAAgD;AAClD;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;IAC3B,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,0EAA0E;EAC5E;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gDAAgD;IAChD,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,sDAAsD;IACtD,cAAc;IACd,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,0EAA0E;IAC1E,gCAAgC;IAChC,8CAA8C;EAChD;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;;IAEE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;;IAEE,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;;;IAIE,WAAW;IACX,cAAc;IACd,kBAAkB;EACpB;;EAEA;;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,8CAA8C;EAChD;;EAEA;;IAEE,wBAAwB;IACxB,qCAAqC;IACrC,oBAAoB;IACpB,wBAAwB;IACxB,oBAAoB;IACpB,0DAA0D;IAC1D,gBAAgB;IAChB,yFAAyF;IACzF,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,iBAAiB;EACnB;;EAEA;;IAEE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,oCAAoC;IACpC,gEAAgE;EAClE;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,wDAAwD;EAC1D;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;;uCAEuC;AACvC;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA,0DAA0D;;;;;AAK1D;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,iCAAiC;EACjC,WAAW;EACX,iCAAiC;EACjC,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;EAC5B,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA,yCAAyC;AACzC;EACE,YAAY;AACd;;;AAGA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mDAAmD;EACnD,SAAS;EACT,MAAM;EACN;gEAC8D;EAC9D,iCAAiC;EACjC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,uCAAuC;EACvC,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf;;;wBAGsB;AACxB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,WAAW;EACX,2CAA2C;EAC3C,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4CAA4C;EAC5C,aAAa;EACb,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,0DAA0D;EAC1D,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,kDAAkD;EAClD,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,6CAA6C;EAC7C,yCAAyC;EACzC,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+CAA+C;EAC/C,gDAAgD;EAChD,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;;;AAKA;;uCAEuC;AACvC,2BAA2B;AAC3B,gDAAgD;AAChD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC;;mCAEiC;EACjC,sEAAsE;AACxE;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yCAAyC;EACzC;;kCAEgC;AAClC;;AAEA,0CAA0C;AAC1C;EACE,kDAAkD;AACpD;;AAEA,YAAY;AACZ;EACE,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;AACpC;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mCAAmC;AACrC;;AAEA,uBAAuB;;AAEvB;;;;8DAI8D;;AAE9D,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,4CAA4C;EAC5C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,0EAA0E;AAC1E;;;;;;;EAOE,6BAA6B;EAC7B,MAAM;EACN,QAAQ;EACR,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;;EAE1B,2BAA2B;EAC3B,8BAA8B;;EAE9B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;;EAEnB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;;EAEtB,yEAAyE;AAC3E;;AAEA,2CAA2C;AAC3C;;;;;;;EAOE,gCAAgC;EAChC,UAAU;EACV,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;;EAEpB,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,uEAAuE;AACzE;;AAEA;EACE,6BAA6B;EAC7B,MAAM;EACN,QAAQ;EACR,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yEAAyE;AAC3E;;AAEA;EACE,gCAAgC;EAChC,UAAU;EACV,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uEAAuE;AACzE;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,mDAAmD;EACnD,UAAU;AACZ;;AAEA;;EAEE,uBAAuB;EACvB,sCAAsC;EACtC,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;EAEE,UAAU;EACV,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,+DAA+D;AAC/D;;;;;;;;;;;;;;EAcE,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;;;;;;;;;;;;;;EAcE,UAAU;EACV,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,cAAc;AACd;;;;;;;EAOE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;;;;EAOE,WAAW;AACb;;;;;;;;AAQA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA,qBAAqB;AACrB;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,oCAAoC;EACpC,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,eAAe;EACf,cAAc;EACd,4BAA4B;;EAE5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;;EAET,mCAAmC;EACnC,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,kCAAkC;;EAElC,cAAc;EACd,wEAAwE;EACxE,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,mCAAmC;EACnC,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;;EAEpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,gBAAgB;;EAEhB,mCAAmC;EACnC,cAAc;EACd,sCAAsC;AACxC;;AAEA,2CAA2C;AAC3C;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;;;AAIA,wBAAwB;AACxB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,iFAAiF;AACjF;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,sDAAsD;EACtD,4DAA4D;EAC5D,uCAAuC;EACvC,qCAAqC;EACrC,6CAA6C;EAC7C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,aAAa;IACb,UAAU;IACV,0BAA0B;IAC1B,WAAW;IACX,UAAU;IACV,eAAe;;IAEf,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;IACtB,sCAAsC;IACtC,mCAAmC;IACnC,8BAA8B;;IAE9B,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;;IAEvB,mCAAmC;IACnC,oCAAoC;IACpC,gBAAgB;IAChB,oCAAoC;IACpC,mBAAmB;;IAEnB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,yDAAyD;EACzD;IACE,WAAW;EACb;;EAEA,kDAAkD;EAClD;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,uBAAuB;IACvB,+BAA+B;IAC/B,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;;;;;EAMA,sCAAsC;EACtC;IACE,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,2EAA2E;IAC3E,qBAAqB;IACrB,UAAU;IACV,wBAAwB;IACxB,WAAW;EACb;;EAEA,kDAAkD;EAClD;IACE,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,2BAA2B;IAC3B,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;EACf;;EAEA;;;;;;qCAMmC;;EAEnC,qBAAqB;EACrB;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;;IAEb,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET,mBAAmB;IACnB,2BAA2B;;IAE3B,8BAA8B;EAChC;;EAEA;;;;IAIE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA,4CAA4C;EAC5C;;;;;;;;;;IAUE,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA,wDAAwD;EACxD;;;;;IAKE,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;;;;IAKE,wBAAwB;EAC1B;;;EAGA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,2CAA2C;IAC3C,mBAAmB;IACnB,qCAAqC;IACrC,cAAc;IACd,kBAAkB;IAClB,8CAA8C;EAChD;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,mBAAmB;IACnB,qCAAqC;IACrC,cAAc;IACd,8CAA8C;EAChD;;EAEA;;IAEE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,qCAAqC;IACrC,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,sDAAsD;IACtD,4DAA4D;IAC5D,uCAAuC;IACvC,qCAAqC;IACrC,8CAA8C;IAC9C,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,iBAAiB;IACjB,kCAAkC;IAClC,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qEAAqE;IACrE,iCAAiC;IACjC,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,+CAA+C;IAC/C,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,+CAA+C;AAC/C;EACE,6BAA6B;EAC7B,MAAM;EACN,QAAQ;EACR,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,yEAAyE;AAC3E;;AAEA;EACE,gCAAgC;EAChC,UAAU;EACV,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uEAAuE;AACzE;;AAEA;;EAEE,uBAAuB;EACvB,sCAAsC;EACtC,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;EAEE,UAAU;EACV,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;;;;;;;;;;;;;IAaE;EACF;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,qDAAqD;IACrD,yBAAyB;IACzB,WAAW;IACX,gDAAgD;EAClD;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,6CAA6C;IAC7C,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,SAAS;IACT,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,iCAAiC;EACnC;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;AAEF;;AAEA,8FAA8F;AAC9F;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;AACF;;AAEA,2FAA2F;AAC3F;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;;;;;;;IAQE,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,kCAAkC;IAClC,6BAA6B;IAC7B,6CAA6C;EAC/C;;EAEA;;;;;;;;IAQE,WAAW;IACX,YAAY;EACd;;EAEA;;;;;;;;;;;;;;;;IAgBE,uBAAuB;IACvB,2BAA2B;IAC3B,sCAAsC;EACxC;;EAEA;;;;;;;;;;;;;;;;IAgBE,UAAU;IACV,wBAAwB;IACxB,gBAAgB;EAClB;AACF;;AAEA,sFAAsF;AACtF;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,uEAAuE;AACzE;;AAEA;EACE;;IAEE,iBAAiB;IACjB,WAAW;EACb;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,+EAA+E;AAC/E;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;IAEE,wEAAwE;IACxE,cAAc;EAChB;AACF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,6FAA6F;AAC7F;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* mapCenterStyles.css */\n\n.map-center-page,\n.map-center-page * {\n  box-sizing: border-box;\n}\n\n.map-center-page .map-center-root {\n  min-width: 0;\n}\n\n@media (max-width: 1199px) {\n  body.map-center-responsive-page #root {\n    margin-left: 0 !important;\n    overflow-x: hidden;\n  }\n\n  body.map-center-responsive-page .sidenav---sidenav---_2tBP {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 12000;\n    width: 0;\n    min-width: 0;\n    overflow: hidden;\n    transform: translateX(-100%);\n    transition: width .2s ease, transform .2s ease;\n  }\n\n  body.map-center-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {\n    width: min(280px, 86vw);\n    min-width: min(280px, 86vw);\n    overflow-y: auto;\n    transform: translateX(0);\n    box-shadow: 8px 0 24px rgba(15, 39, 60, .22);\n  }\n\n  .map-center-page #layout-navbar {\n    min-height: 64px;\n    padding: 4px 12px 4px 8px;\n  }\n\n  .map-center-page #layout-navbar .app-brand-link {\n    display: flex;\n    flex: 1 1 auto;\n    min-width: 0;\n    align-items: center;\n    justify-content: flex-start;\n    margin-right: 0;\n    overflow: hidden;\n  }\n\n  .map-center-page #layout-navbar .trafico-mobile-menu-toggle {\n    display: inline-flex;\n    flex: 0 0 44px;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    margin-right: 8px;\n    padding: 0;\n    border: 0;\n    border-radius: 10px;\n    background: transparent;\n    color: #006699;\n    font-size: 25px;\n    cursor: pointer;\n  }\n\n  .map-center-page #layout-navbar .app-brand-link img {\n    display: block;\n    width: min(190px, 100%);\n    max-width: 100%;\n    height: 54px !important;\n    object-fit: contain;\n    object-position: left center;\n  }\n\n  .map-center-page #layout-navbar .navbar-nav-right {\n    position: static;\n    flex: 0 0 auto;\n    min-width: 0;\n  }\n\n  .map-center-page #layout-navbar .navbar-actions {\n    gap: 4px;\n  }\n\n  .map-center-page #layout-navbar .nav-notify,\n  .map-center-page #layout-navbar .nav-avatar {\n    flex: 0 0 auto;\n  }\n\n  .map-center-page #layout-navbar .notification-icon {\n    font-size: 26px;\n  }\n\n  .map-center-page #layout-navbar .notificationsCount {\n    min-width: 24px;\n    height: 20px;\n    padding: 1px 5px;\n    font-size: 11px;\n    line-height: 18px;\n  }\n\n  .map-center-page #layout-navbar .avatar-img {\n    width: 40px;\n    height: 40px;\n  }\n\n  .map-center-page .map-center-root .map-container {\n    min-height: calc(100vh - 128px);\n    max-height: calc(100vh - 128px);\n  }\n}\n\n@media (max-width: 767px) {\n  .map-center-page #layout-navbar {\n    min-height: 60px;\n    padding: 4px 8px;\n  }\n\n  .map-center-page #layout-navbar .app-brand-link img {\n    width: min(172px, 100%);\n    height: 48px !important;\n    object-fit: contain;\n    object-position: left center;\n  }\n\n  .map-center-page #layout-navbar .notification-icon {\n    font-size: 24px;\n  }\n\n  .map-center-page #layout-navbar .avatar-img {\n    width: 38px;\n    height: 38px;\n  }\n\n  .map-center-page .map-center-root .map-container {\n    min-height: calc(100vh - 124px);\n    max-height: calc(100vh - 124px);\n  }\n}\n\n/* 0) Wrapper global */\n.map-center-root .map-container {\n  position: relative;\n  width: 100%;\n  height: 90vh;\n  overflow: hidden;\n  z-index: 999 !important;\n}\n\n.tour-first p {\n  margin: 0 0 10px;\n}\n\n.tour-skip-btn {\n  background: transparent;\n  border: 1px solid #006699;\n  color: #006699;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n\n.tour-skip-btn:hover {\n  background: rgba(0, 102, 153, 0.08);\n}\n\n.map-center-root.has-bottom-grid .map-container {\n  height: 70vh;\n}\n\n.map-center-root .bottom-device-grid {\n  width: 100%;\n  padding: 8px 12px 12px;\n  background: #f7f9fb;\n  border-top: 1px solid #d8e1e8;\n  display: flex;\n  flex-direction: column;\n}\n\n.map-center-root .bottom-device-grid__inner {\n  display: grid;\n  grid-auto-flow: column;\n  grid-auto-columns: minmax(260px, 1fr);\n  gap: 12px;\n  overflow-x: auto;\n  padding-bottom: 6px;\n  height: 100%;\n  align-content: start;\n}\n\n.map-center-root .bottom-device-card {\n  min-width: 260px;\n}\n\n.map-center-root .bottom-device-table {\n  width: 100%;\n  padding: 8px 12px 12px;\n  background: #f7f9fb;\n  border-top: 1px solid #d8e1e8;\n  display: flex;\n  flex-direction: column;\n}\n\n.map-center-root .bottom-device-table__inner {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: auto;\n  height: 100%;\n}\n\n.map-center-root .bottom-device-table__table {\n  width: 100%;\n  min-width: 900px;\n  border-collapse: collapse;\n  background: #fff;\n}\n\n.map-center-root .bottom-device-table__table th,\n.map-center-root .bottom-device-table__table td {\n  padding: 2px 6px;\n  border-bottom: 1px solid #e2e8f0;\n  text-align: left;\n  font-size: 0.85rem;\n  white-space: normal;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n  line-height: 1.2;\n  text-align: start;\n}\n\n.map-center-root .bottom-device-table__table thead th {\n  position: sticky;\n  top: 0;\n  background: #006699;\n  color: #fff;\n  font-weight: 700;\n}\n\n.map-center-root .bottom-device-table__table tbody tr:hover {\n  background: #f2f7fb;\n  cursor: pointer;\n}\n\n.map-center-root .bottom-device-table__table tbody tr.is-selected {\n  background: #c8d7e4;\n  font-weight: 800;  \n}\n\n\n\n.map-center-root .bottom-resize-handle {\n  height: 8px;\n  cursor: row-resize;\n  background: linear-gradient(180deg, #dbe6ef 0%, #c9d7e2 100%);\n  border-top: 1px solid #b9c9d6;\n  border-bottom: 1px solid #b9c9d6;\n}\n\n.map-center-root .bottom-resize-handle:hover {\n  background: linear-gradient(180deg, #cfddea 0%, #bacbd8 100%);\n}\n\n.map-center-root .bottom-device-table__icons {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.map-center-root .map-fullscreen-control {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 1201;\n}\n\n.map-center-root .map-fullscreen-button {\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  min-height: 40px;\n  padding: 0;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  border: 1px solid #ddd;\n  color: #1f2933;\n  box-sizing: border-box;\n}\n\n.map-center-root .geocercas-place-search {\n  position: relative;\n  z-index: 1;\n  flex: 0 0 auto;\n  width: 100%;\n  min-height: 54px;\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  box-sizing: border-box;\n  padding: 0 12px 0 18px;\n  border: 1px solid rgba(15, 76, 129, 0.15);\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.96);\n  box-shadow: 0 16px 30px rgba(7, 53, 79, 0.16);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n}\n\n.map-center-root .geocercas-place-search:focus-within {\n  border-color: rgba(26, 160, 216, 0.58);\n  box-shadow: 0 20px 40px rgba(7, 53, 79, 0.2), 0 0 0 3px rgba(26, 160, 216, 0.13);\n}\n\n.map-center-root .geocercas-place-search__icon {\n  flex: 0 0 auto;\n  color: #0f4c81;\n  font-size: 17px;\n}\n\n.map-center-root .geocercas-place-search__input {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 50px;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: #16324a;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.map-center-root .geocercas-place-search__input::placeholder {\n  color: #8296a8;\n  font-weight: 500;\n  opacity: 1;\n}\n\n.map-center-root .geocercas-place-search__input::-webkit-search-cancel-button {\n  display: none;\n}\n\n.map-center-root .geocercas-place-search__clear {\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  padding: 0 0 2px;\n  border: 0;\n  border-radius: 11px;\n  background: linear-gradient(135deg, rgba(15, 76, 129, 0.1), rgba(26, 160, 216, 0.16));\n  color: #0f4c81;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.map-center-root .geocercas-place-search__clear:hover {\n  background: linear-gradient(135deg, rgba(15, 76, 129, 0.17), rgba(26, 160, 216, 0.24));\n}\n\n.map-center-root .mapcenter-place-search-shell {\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: min(520px, calc(100vw - 180px));\n  z-index: 1202;\n  pointer-events: none;\n}\n\n.map-center-root .mapcenter-place-search-shell.with-fast-filters {\n  top: 86px;\n}\n\n.map-center-root .mapcenter-place-search {\n  width: 100%;\n  min-height: 58px;\n  pointer-events: auto;\n}\n\n/* Google inserta las sugerencias fuera del contenedor de React. */\n.pac-container {\n  z-index: 100000 !important;\n  margin-top: 7px;\n  overflow: hidden;\n  border: 1px solid rgba(15, 76, 129, 0.13);\n  border-radius: 16px;\n  box-shadow: 0 20px 42px rgba(7, 53, 79, 0.2);\n  font-family: inherit;\n}\n\n.pac-item {\n  padding: 9px 14px;\n  border-top-color: rgba(15, 76, 129, 0.08);\n  color: #5d7489;\n  cursor: pointer;\n}\n\n.pac-item:hover,\n.pac-item-selected {\n  background: #eef7fc;\n}\n\n.pac-item-query {\n  color: #16324a;\n  font-size: 13px;\n}\n\n@media (max-width: 767px) {\n  .map-center-root .geocercas-place-search {\n    width: 100%;\n    min-height: 52px;\n    padding-left: 16px;\n    border-radius: 16px;\n  }\n\n  .map-center-root .mapcenter-place-search-shell {\n    top: 72px;\n    width: calc(100vw - 104px);\n  }\n\n  .map-center-root .mapcenter-place-search-shell.with-fast-filters {\n    top: 146px;\n  }\n}\n\n.map-center-root .map-fullscreen-button:hover {\n  background: #f0f5f9;\n}\n\n.map-center-root .map-fullscreen-button.active {\n  background: #006699;\n  border-color: #006699;\n  color: #fff;\n}\n\n.map-center-root .map-cargotronics-logo {\n  position: absolute;\n  top: 4px;\n  right: 64px;\n  width: 180px;\n  height: 64px;\n  object-fit: contain;\n  pointer-events: none;\n  z-index: 1302;\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.map-center-root.is-fullscreen .map-cargotronics-logo {\n  opacity: 0.55;\n  pointer-events: auto;\n}\n\n.map-center-root.is-fullscreen .map-cargotronics-logo:hover {\n  opacity: 1;\n}\n\nbody.map-center-fullscreen #layout-navbar,\nbody.map-center-fullscreen .layout-navbar,\nbody.map-center-fullscreen .sidenav---sidenav---_2tBP {\n  display: none !important;\n}\n\nbody.map-center-fullscreen .map-center-root .map-actions-stack .action-item .fast-info-button,\n.map-center-root.is-fullscreen .map-actions-stack .action-item .fast-info-button {\n  display: none !important;\n}\n\nbody.map-center-fullscreen .layout-page {\n  padding-top: 0 !important;\n}\n\n\n.map-center-root .badge {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n}\n\n.map-center-root .icon-refuerzo {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #dc3545;\n}\n\n.badge-refuerzo {\n  color: #fff;\n  background-color: #17a2b8 !important;\n}\n\n.map-center-root .badge-danger {\n  color: #1a1717 !important;\n  background-color: #dc3545 !important;\n}\n\n\n/* ----------------------------------\n   3) Fila de alertas (íconos) sobre el mapa\n   ---------------------------------- */\n.map-center-root .alerts-row {\n  position: absolute;\n  top: 15px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 1rem;\n  z-index: 22;\n  /* Por encima de controles y botón */\n}\n\n.map-center-root .alert-icon {\n  position: relative;\n  width: 48px;\n  height: 48px;\n  background-color: #fff;\n  border-radius: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n\n.map-center-root .alert-icon:hover {\n  transform: translateY(-2px);\n}\n\n.map-center-root .alert-icon.active {\n  background-color: #dfdddd;\n  box-shadow: 0px 4px 6px #006699,\n    0px 8px 15px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.map-center-root .map-live-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: #e11d48;\n  box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.7);\n  animation: map-live-pulse 1.2s ease-out infinite;\n}\n\n@keyframes map-live-pulse {\n  0% {\n    transform: scale(0.9);\n    box-shadow: 0 0 0 0 rgba(225, 29, 72, 0.7);\n  }\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 8px rgba(225, 29, 72, 0);\n  }\n  100% {\n    transform: scale(0.9);\n    box-shadow: 0 0 0 0 rgba(225, 29, 72, 0);\n  }\n}\n\n.map-center-root .fast-filters-button {\n  position: absolute;\n  top: 10px;\n  right: 57px;\n  z-index: 920;\n  width: 114px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n}\n\n.map-center-root .fast-geocerca-button {\n  position: absolute;\n  top: 56px;\n  /* 👈 debajo del botón de filtros */\n  right: 57px;\n  /* 👈 misma columna que filtros */\n  z-index: 1000;\n  width: 112px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10px;\n}\n\n.map-center-root .fast-georutas-button {\n  position: absolute;\n  top: 102px;\n  /* 👈 debajo de geocercas */\n  right: 57px;\n  /* 👈 misma columna */\n  z-index: 1000;\n  width: 112px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10px;\n}\n\n.map-center-root .fast-invias-button {\n  position: absolute;\n  top: 194px;\n  /* debajo de dispositivos */\n  right: 57px;\n  z-index: 1000;\n  width: 112px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10px;\n}\n\n\n\n.map-center-root .fast-filters-button.active::after {\n  content: \"\";\n  position: absolute;\n  top: -2px;\n  /* ajústalo hasta que quede centrado */\n  right: -2px;\n  /* ajústalo para que no pise el ícono */\n  width: 8px;\n  height: 8px;\n  background: #006699;\n  border-radius: 50%;\n  animation: pulse 1.5s infinite ease-in-out;\n}\n\n.map-center-root .fast-geocerca-button.active::after {\n  content: \"\";\n  position: absolute;\n  top: -2px;\n  /* ajústalo hasta que quede centrado */\n  right: -2px;\n  /* ajústalo para que no pise el ícono */\n  width: 8px;\n  height: 8px;\n  background: #006699;\n  border-radius: 50%;\n  animation: pulse 1.5s infinite ease-in-out;\n}\n\n.map-center-root .fast-georutas-button.active::after {\n  content: \"\";\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 8px;\n  height: 8px;\n  background: #006699;\n  border-radius: 50%;\n  animation: pulse 1.5s infinite ease-in-out;\n}\n\n.map-center-root .fast-invias-button.active::after {\n  content: \"\";\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 8px;\n  height: 8px;\n  background: #006699;\n  border-radius: 50%;\n  animation: pulse 1.5s infinite ease-in-out;\n}\n\n\n.map-center-root .badge {\n  position: absolute;\n  bottom: -6px;\n  right: -6px;\n  background-color: #e74c3c;\n  color: #fff;\n  font-size: 0.75rem;\n  padding: 2px 6px;\n  border-radius: 12px;\n  line-height: 1;\n}\n\n/* ----------------------------------\n   4) Botón Offcanvas / filtro\n   ---------------------------------- */\n.map-center-root .sidebar-toggle-btn {\n  position: absolute;\n  top: 60px;\n  /* Ajusta según tu layout */\n  right: 10px;\n  z-index: 20;\n  /* Detrás de Google Maps (21) */\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  border-radius: 4px;\n  padding: 8px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);\n  transition: background 0.15s;\n}\n\n.map-center-root .sidebar-toggle-btn:hover {\n  background: rgba(255, 255, 255, 1);\n}\n\n/* ----------------------------------\n   5) Controles de Google Maps \n   ---------------------------------- */\n.map-center-root .gm-control-active,\n.map-center-root .gmnoprint,\n.map-center-root .gm-bundled-control {\n  z-index: 21;\n}\n\n/* ----------------------------------\n   6) Contenedor del mapa\n   ---------------------------------- */\n.map-center-root .map-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n}\n\n.map-center-root #map {\n  width: 100%;\n  height: 100vh;\n}\n\n/* ----------------------------------\n   7) Ajustes al Offcanvas (reactstrap)\n   ---------------------------------- */\n\n\n\n/* no dañes otros offcanvas end */\n\n\n/* ---------- DEFAULT (desktop) ---------- */\n.offcanvas-backdrop.show {\n  position: fixed !important;\n  top: 0px !important;\n  left: 0 !important;\n  /* desktop: NO recorta por sidenav */\n  right: 0 !important;\n  bottom: 0 !important;\n  background: rgba(0, 0, 0, 0.25) !important;\n  z-index: 2500 !important;\n}\n\n.offcanvas.custom-offcanvas-map-center {\n  position: fixed !important;\n  top: 0px !important;\n  bottom: 0 !important;\n  height: calc(100vh - 0px) !important;\n\n  right: 0 !important;\n  left: auto !important;\n  /* desktop: normal */\n  margin-left: 0 !important;\n  /* desktop: normal */\n\n  width: 380px !important;\n  max-width: 100vw !important;\n  z-index: 2600 !important;\n}\n\n\n/* ----------------------------------\n   8) Dropdown “Dispositivos”\n   ---------------------------------- */\n.map-center-root .menu-dropdown {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.map-center-root .device-item {\n  padding: 0.4rem 0;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.map-center-root .device-item:hover {\n  background-color: #f8f9fa;\n}\n\n/* ----------------------------------\n   9) Tarjetas de dispositivos\n   ---------------------------------- */\n.map-center-root .device-card {\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  display: flex;\n  align-items: start;\n  justify-content: start;\n}\n\n.map-center-root .device-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);\n}\n\n.map-center-root .device-cards {\n  max-height: 65vh;\n  overflow-y: auto;\n}\n\n/* Offcanvas custom */\n.map-center-root .offcanvas.custom-offcanvas-map-center {\n  width: 380px !important;\n  max-width: 90%;\n  z-index: 2601 !important;\n}\n\n/* Menú derecho desplegable */\n.map-center-root .right-dropdown-menu {\n  position: absolute;\n  top: 6.8rem;\n  right: 1rem;\n  width: 300px;\n  /* min-height: 420px; */\n  /* background: #fff; */\n  /* border: 1px solid #ddd; */\n  border-radius: 4px;\n  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2); */\n  z-index: 1002;\n}\n\n.map-center-root .left-dropdown-menu {\n  position: absolute;\n  top: calc(70px + 38px + 10px) !important;\n  /* ajusta a tu gusto */\n  left: 12px;\n  /* ✅ a la izquierda */\n  right: auto;\n  width: 300px;\n  /* o el ancho que usabas */\n  z-index: 1000;\n}\n\n/* El tab de colapsar debe “pegar” abajo del panel */\n.map-center-root .devices-toggle-tab.devices-toggle-tab--left {\n  position: sticky;\n  /* o relative si ya lo manejas así */\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 910 !important;\n}\n\n.map-center-root .left-dropdown-menu .menu-item {\n  padding: 0.6rem 1rem;\n  cursor: pointer;\n}\n\n.map-center-root .right-dropdown-menu .menu-item {\n  padding: 0.6rem 1rem;\n  cursor: pointer;\n}\n\n.map-center-root .right-dropdown-menu .menu-item:hover {\n  background: #f5f5f5;\n}\n\n.map-center-root .left-dropdown-menu .menu-item:hover {\n  background: #f5f5f5;\n}\n\n/* Contenedor de dispositivos */\n.right-dropdown-menu .device-cards {\n  overflow-y: auto;\n  scrollbar-width: none;\n  /* Firefox */\n  -ms-overflow-style: none;\n  /* IE/Edge legacy */\n}\n\n.left-dropdown-menu .device-cards {\n  overflow-y: auto;\n  scrollbar-width: none;\n  /* Firefox */\n  -ms-overflow-style: none;\n  /* IE/Edge legacy */\n}\n\n.right-dropdown-menu .device-cards::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.left-dropdown-menu .device-cards::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n\n/* ----------------------------------\n   10) InfoWindow HTML interno\n   ---------------------------------- */\n.info-window-selected-container,\n.info-window-selected-body {\n  height: auto !important;\n  max-height: none !important;\n  overflow-y: visible !important;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.info-window-selected-container {\n  padding: 0 !important;\n  border-radius: 26px !important;\n}\n\n.info-window-selected-body {\n  display: flex;\n  justify-content: center;\n  width: 100% !important;\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  box-sizing: border-box;\n}\n\n.info-window-selected-container::-webkit-scrollbar,\n.info-window-selected-body::-webkit-scrollbar {\n  display: none;\n  width: 0;\n  height: 0;\n}\n\n.info-window-selected {\n  display: flex;\n  justify-content: center;\n  width: fit-content;\n  max-width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  box-sizing: border-box;\n  background: #ffffff;\n}\n\n.info-window-selected > .info-window-card {\n  margin-right: auto;\n  margin-left: auto;\n  background: #ffffff;\n  border: 0 !important;\n  top: 0 !important;\n}\n\n.info-window-selected .info-window-content {\n  margin-top: 0 !important;\n}\n\n.map-center-root .info-window-card {\n  --iw-primary: #0f6ea8;\n  --iw-accent: #1ca3ec;\n  --iw-ink: #14324a;\n  --iw-muted: #6f8597;\n  --iw-surface: #ffffff;\n  --iw-bg: #ffffff;\n  --iw-border: #d8e6f5;\n  --iw-shadow: 0 18px 40px rgba(15, 57, 95, 0.12);\n  width: min(620px, calc(100vw - 56px));\n  max-width: calc(100vw - 56px);\n  top: 20px;\n  font-family: \"Segoe UI\", sans-serif;\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow: var(--iw-shadow);\n  position: relative;\n  z-index: 12010;\n  background: var(--iw-bg);\n  border: 1px solid var(--iw-border);\n}\n\n.mobile-detail-offcanvas .offcanvas-header {\n  align-items: flex-start;\n  background:\n    radial-gradient(circle at top right, rgba(28, 163, 236, 0.18), transparent 28%),\n    linear-gradient(135deg, #f4f8fc 0%, #ecf3fb 55%, #f9fbff 100%);\n  color: #fff;\n  border-bottom: 1px solid #d8e6f5;\n  padding: 18px 18px 14px;\n  box-shadow: 0 10px 24px rgba(15, 57, 95, 0.1);\n}\n\n.mobile-detail-offcanvas .offcanvas-header .btn-close {\n  opacity: 0.85;\n}\n\n.mobile-detail-offcanvas__header {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-right: 8px;\n}\n\n.mobile-detail-offcanvas__eyebrow {\n  font-size: 0.72rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  opacity: 1;\n  color: #5f7a90;\n  text-shadow: none;\n}\n\n.mobile-detail-offcanvas__header strong {\n  font-size: 1.45rem;\n  line-height: 1.05;\n  letter-spacing: 0.01em;\n  color: #14324a;\n  text-shadow: none;\n}\n\n.mobile-detail-offcanvas__body {\n  padding: 0 !important;\n  background: linear-gradient(180deg, #f4f8fc 0%, #eef5fc 24%, #f9fbff 100%);\n}\n\n.mobile-detail-offcanvas .info-window-card {\n  width: 100%;\n  max-width: none;\n  min-height: 100%;\n  border-radius: 0;\n  box-shadow: none;\n  background: transparent;\n}\n\n.mobile-detail-offcanvas .info-window-content {\n  width: 100%;\n  padding: 14px 16px 20px;\n  box-sizing: border-box;\n}\n\n.mobile-detail-offcanvas .info-window-topbar {\n  display: none !important;\n}\n\n.mobile-detail-offcanvas .info-window-summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  padding: 0 0 4px;\n}\n\n.mobile-detail-offcanvas .info-window-summary__chip {\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(11, 83, 125, 0.12);\n  border-radius: 16px;\n  padding: 12px 10px;\n  box-shadow: 0 10px 20px rgba(15, 53, 83, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.mobile-detail-offcanvas .info-window-summary__label {\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #4f6478;\n}\n\n.mobile-detail-offcanvas .info-window-summary__chip strong {\n  color: #082c46;\n  font-size: 0.92rem;\n  line-height: 1.2;\n}\n\n.mobile-detail-offcanvas .info-window-section {\n  margin: 14px 0 0;\n  border-radius: 20px;\n}\n\n.map-center-root .info-window-topbar {\n  display: none;\n}\n\n.map-center-root .info-window-content,\n.mobile-detail-offcanvas .info-window-content {\n  width: 100%;\n  max-width: 100%;\n  padding: 8px 10px 10px;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.map-center-root .info-window-summary,\n.mobile-detail-offcanvas .info-window-summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 6px;\n  margin-bottom: 7px;\n}\n\n.map-center-root .info-window-summary__chip,\n.mobile-detail-offcanvas .info-window-summary__chip {\n  background: rgba(255, 255, 255, 0.86);\n  border: 1px solid #dbe8f6;\n  border-radius: 12px;\n  padding: 6px 8px;\n  box-shadow: 0 10px 24px rgba(15, 57, 95, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.map-center-root .info-window-summary__label,\n.mobile-detail-offcanvas .info-window-summary__label {\n  font-size: 0.6rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--iw-muted);\n}\n\n.map-center-root .info-window-summary__chip strong,\n.mobile-detail-offcanvas .info-window-summary__chip strong {\n  color: var(--iw-ink);\n  font-size: 0.82rem;\n  line-height: 1.15;\n}\n\n.map-center-root .info-window-kicker {\n  font-size: 0.72rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #5f7a90;\n  text-shadow: none;\n}\n\n.map-center-root .info-window-close-btn {\n  width: 38px;\n  height: 38px;\n  border: 1px solid #cfe7fb;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #ffffff;\n  color: var(--iw-primary);\n  flex: none;\n}\n\n.map-center-root .info-window-close-btn:hover {\n  background: #f2f9ff;\n}\n\n.map-center-root .info-window-header,\n.mobile-detail-offcanvas .info-window-header {\n  padding: 0.48rem 0.75rem;\n  font-weight: 700;\n  border-radius: 16px 16px 0 0;\n  margin: 0;\n  color: #ffffff !important;\n  background: linear-gradient(135deg, var(--iw-primary, #0f6ea8), var(--iw-accent, #1ca3ec));\n  font-size: 0.8rem;\n  letter-spacing: 0.01em;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.28);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18);\n}\n\n.map-center-root .info-window-header,\n.mobile-detail-offcanvas .info-window-header {\n  color: #ffffff !important;\n}\n\n.map-center-root .info-window-body {\n  padding: 0.2rem 0.7rem 0.35rem;\n  background: transparent;\n  min-width: 0;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  column-gap: 14px;\n}\n\n.map-center-root .info-window-section,\n.mobile-detail-offcanvas .info-window-section {\n  margin-top: 7px;\n  border-radius: 14px;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.78);\n  border: 1px solid #dbe8f6;\n  box-shadow: 0 12px 28px rgba(15, 57, 95, 0.08);\n}\n\n.map-center-root .info-window-section--contract .info-window-header,\n.mobile-detail-offcanvas .info-window-section--contract .info-window-header {\n  background: linear-gradient(135deg, #0d5f93 0%, #1782c2 100%);\n}\n\n.map-center-root .info-window-section--driver .info-window-header,\n.mobile-detail-offcanvas .info-window-section--driver .info-window-header {\n  background: linear-gradient(135deg, #0b567f 0%, #1270ab 100%);\n}\n\n.map-center-root .info-row,\n.mobile-detail-offcanvas .info-row {\n  display: grid;\n  grid-template-columns: minmax(120px, 42%) minmax(0, 1fr);\n  align-items: flex-start;\n  column-gap: 8px;\n  row-gap: 3px;\n  margin-bottom: 0;\n  padding: 0.3rem 0;\n  border-bottom: 1px solid #e4edf7;\n}\n\n.map-center-root .info-row:last-child,\n.mobile-detail-offcanvas .info-row:last-child {\n  border-bottom: 0;\n  padding-bottom: 0.1rem;\n}\n\n.map-center-root .info-label,\n.mobile-detail-offcanvas .info-label {\n  color: #446983;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.map-center-root .info-value,\n.mobile-detail-offcanvas .info-value {\n  font-weight: 800;\n  color: var(--iw-ink);\n  text-align: start;\n  min-width: 0;\n  overflow-wrap: anywhere;\n  display: block;\n  font-size: 0.8rem;\n  line-height: 1.2;\n}\n\n.map-center-root .info-window-action-btn,\n.mobile-detail-offcanvas .info-window-action-btn {\n  font-size: 0.72rem;\n  font-weight: 700;\n  min-width: 104px;\n  min-height: 36px;\n  margin: 0 !important;\n  border-radius: 11px;\n  border-width: 1px;\n  background: #fff;\n  flex: 1 1 calc(33.333% - 10px);\n  width: auto;\n  max-width: 100%;\n  padding: 0 10px;\n  box-shadow: 0 8px 18px rgba(16, 52, 79, 0.06);\n  border-style: solid;\n  border-color: #d4dde6;\n  text-align: center;\n  line-height: 1.15;\n  white-space: normal;\n  box-sizing: border-box;\n}\n\n.map-center-root .info-window-actions,\n.mobile-detail-offcanvas .info-window-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: stretch;\n  gap: 6px;\n  padding: 0.4rem 0.55rem 0.5rem;\n  background: transparent;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.map-center-root .info-window-actions {\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.map-center-root .info-window-action-btn {\n  min-width: 0;\n  flex: 1 1 0;\n  padding: 0 10px;\n  font-size: 0.8rem;\n}\n\n.map-center-root .info-window-actions::-webkit-scrollbar,\n.mobile-detail-offcanvas .info-window-actions::-webkit-scrollbar {\n  display: none;\n}\n\n.map-center-root .info-window-action-btn--primary,\n.mobile-detail-offcanvas .info-window-action-btn--primary {\n  color: #ffffff;\n  border-color: transparent;\n  background: linear-gradient(135deg, var(--iw-primary), var(--iw-accent));\n  box-shadow: 0 10px 24px rgba(24, 119, 179, 0.22);\n}\n\n.map-center-root .info-window-action-btn--neutral,\n.mobile-detail-offcanvas .info-window-action-btn--neutral {\n  color: #165c8a;\n  border-color: #9cc8eb;\n}\n\n.map-center-root .info-window-action-btn--info,\n.mobile-detail-offcanvas .info-window-action-btn--info {\n  color: #165c8a;\n  border-color: #9cc8eb;\n}\n\n.map-center-root .info-window-action-btn--danger,\n.mobile-detail-offcanvas .info-window-action-btn--danger {\n  color: #d63b3b;\n  border-color: #f4b9b9;\n}\n\n.map-center-root .info-window-action-btn--success,\n.mobile-detail-offcanvas .info-window-action-btn--success {\n  color: #2d9c2d;\n  border-color: #bfe8b7;\n}\n\n.map-center-root .info-window-live-btn,\n.mobile-detail-offcanvas .info-window-live-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.map-center-root .info-window-live-dot,\n.mobile-detail-offcanvas .info-window-live-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #dc3545;\n  box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);\n  animation: info-window-pulse 1.2s ease-out infinite;\n  flex: none;\n}\n\n@keyframes info-window-pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);\n  }\n  100% {\n    box-shadow: 0 0 0 8px rgba(220, 53, 69, 0);\n  }\n}\n\n@media (max-width: 768px) {\n  body.mobile-detail-offcanvas-open .offcanvas-backdrop.show {\n    left: 0 !important;\n    width: 100vw !important;\n    z-index: 2999 !important;\n  }\n\n  .offcanvas.mobile-detail-offcanvas {\n    inset: 0 !important;\n    width: 100vw !important;\n    max-width: 100vw !important;\n    height: 100dvh !important;\n    left: 0 !important;\n    right: 0 !important;\n    margin-left: 0 !important;\n    z-index: 3000 !important;\n  }\n\n  .info-window-mobile-shell {\n    position: fixed !important;\n    inset: 0 !important;\n    width: 100vw !important;\n    height: 100dvh !important;\n    z-index: 20000 !important;\n    pointer-events: auto !important;\n  }\n\n  .info-window-mobile-shell > div {\n    inset: 0 !important;\n  }\n\n  .info-window-mobile-shell .gm-style-iw-c {\n    padding: 0 !important;\n    border-radius: 0 !important;\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  .info-window-mobile-shell .gm-style-iw-t,\n  .info-window-mobile-shell .gm-style-iw-tc,\n  .info-window-mobile-shell .gm-style-iw-chr {\n    display: none !important;\n  }\n\n  .info-window-mobile-body {\n    max-height: 100dvh !important;\n    overflow: hidden !important;\n    padding: 0 !important;\n  }\n\n  .map-center-root .info-window-card {\n    width: 100vw;\n    max-width: 100vw;\n    min-height: 100dvh;\n    border-radius: 0;\n    box-shadow: none;\n    display: flex;\n    flex-direction: column;\n    background: linear-gradient(180deg, #f4f8fc 0%, #eef5fc 24%, #f9fbff 100%);\n  }\n\n  .mobile-detail-offcanvas .info-window-card {\n    width: 100%;\n    max-width: 100%;\n    min-height: auto;\n    display: block;\n    background: transparent;\n  }\n\n  .mobile-detail-offcanvas .info-window-content {\n    padding: 14px 14px 24px;\n  }\n\n  .mobile-detail-offcanvas .info-window-summary {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 8px;\n    margin-bottom: 10px;\n  }\n\n  .mobile-detail-offcanvas .info-window-summary__chip {\n    padding: 10px 10px 9px;\n    border-radius: 14px;\n  }\n\n  .mobile-detail-offcanvas .info-window-summary__label {\n    font-size: 0.6rem;\n    letter-spacing: 0.07em;\n  }\n\n  .mobile-detail-offcanvas .info-window-summary__chip strong {\n    font-size: 0.9rem;\n    line-height: 1.2;\n  }\n\n  .map-center-root .info-window-topbar {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    padding: max(16px, env(safe-area-inset-top)) 16px 14px;\n    color: #14324a;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    background: linear-gradient(135deg, #f4f8fc 0%, #ecf3fb 55%, #f9fbff 100%);\n    border-bottom: 1px solid #d8e6f5;\n    box-shadow: 0 10px 24px rgba(15, 57, 95, 0.08);\n  }\n\n  .map-center-root .info-window-topbar-copy {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .map-center-root .info-window-header {\n    padding: 0.88rem 1rem;\n    font-size: 0.95rem;\n  }\n\n  .mobile-detail-offcanvas .info-window-header {\n    padding: 0.78rem 0.9rem;\n    font-size: 0.86rem;\n    letter-spacing: 0.01em;\n  }\n\n  .map-center-root .info-window-body {\n    padding: 0.35rem 0.9rem 0.8rem;\n  }\n\n  .mobile-detail-offcanvas .info-window-body {\n    padding: 0.25rem 0.85rem 0.65rem;\n  }\n\n  .map-center-root .info-window-body,\n  .mobile-detail-offcanvas .info-window-body {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .map-center-root .info-window-summary,\n  .mobile-detail-offcanvas .info-window-summary {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .map-center-root .info-row,\n  .mobile-detail-offcanvas .info-row {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 14px;\n    margin-bottom: 0;\n    padding: 0.8rem 0;\n  }\n\n  .mobile-detail-offcanvas .info-row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    gap: 6px;\n    padding: 0.72rem 0;\n    align-items: start;\n  }\n\n  .map-center-root .info-label,\n  .mobile-detail-offcanvas .info-label,\n  .map-center-root .info-value,\n  .mobile-detail-offcanvas .info-value {\n    width: auto;\n    flex: 0 1 auto;\n    font-size: 0.96rem;\n  }\n\n  .map-center-root .info-label,\n  .mobile-detail-offcanvas .info-label {\n    color: #446983;\n    max-width: 45%;\n    padding-right: 8px;\n  }\n\n  .mobile-detail-offcanvas .info-label {\n    max-width: none;\n    padding-right: 0;\n    font-size: 0.72rem;\n    letter-spacing: 0.06em;\n    line-height: 1.25;\n  }\n\n  .map-center-root .info-value,\n  .mobile-detail-offcanvas .info-value {\n    text-align: right;\n    color: #14324a;\n    max-width: 55%;\n  }\n\n  .mobile-detail-offcanvas .info-value {\n    max-width: none;\n    text-align: left;\n    font-size: 0.98rem;\n    line-height: 1.32;\n  }\n\n  .map-center-root .info-window-section,\n  .mobile-detail-offcanvas .info-window-section {\n    margin-top: 12px;\n    border-radius: 18px;\n  }\n\n  .mobile-detail-offcanvas .info-window-section {\n    border-radius: 16px;\n    box-shadow: 0 12px 24px rgba(15, 53, 83, 0.07);\n  }\n\n  .map-center-root .info-window-actions,\n  .mobile-detail-offcanvas .info-window-actions {\n    display: grid !important;\n    grid-template-columns: minmax(0, 1fr);\n    align-items: stretch;\n    justify-content: stretch;\n    gap: 10px !important;\n    padding: 0.9rem 0 calc(20px + env(safe-area-inset-bottom));\n    margin-top: 14px;\n    background: linear-gradient(180deg, rgba(248, 251, 253, 0) 0%, #f8fbfd 18%, #f8fbfd 100%);\n    position: sticky;\n    bottom: 0;\n    width: 100%;\n    overflow: visible;\n  }\n\n  .map-center-root .info-window-action-btn,\n  .mobile-detail-offcanvas .info-window-action-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    min-width: 0;\n    min-height: 46px;\n    border-radius: 12px;\n    padding: 10px 12px;\n    margin: 0 !important;\n    background: #fff;\n  }\n\n  .mobile-detail-offcanvas .info-window-action-btn--primary {\n    color: #ffffff !important;\n    border-color: transparent !important;\n    background: linear-gradient(135deg, #0f6ea8, #1ca3ec) !important;\n  }\n\n  .mobile-detail-offcanvas .info-window-actions {\n    position: static;\n    margin-top: 0;\n    background: transparent;\n    padding-bottom: calc(20px + env(safe-area-inset-bottom));\n  }\n\n  .mobile-detail-offcanvas__eyebrow {\n    font-size: 0.66rem;\n    letter-spacing: 0.08em;\n    color: #5f7a90;\n  }\n\n  .mobile-detail-offcanvas__header strong {\n    font-size: 1.2rem;\n    line-height: 1.08;\n    color: #14324a;\n  }\n}\n\n/* ----------------------------------\n   11) Input + botón filtro\n   ---------------------------------- */\n.map-center-root .search-filter-container {\n  position: absolute;\n  top: 3.8rem;\n  left: 12px;\n  right: auto !important;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  z-index: 1002;\n}\n\n/* el buscador y botón quedan arriba del panel izquierdo */\n\n\n\n\n.map-center-root .search-input {\n  width: 255px;\n  height: 38px;\n  padding: 0 8px;\n  font-size: 0.9rem;\n  flex: none;\n  box-sizing: border-box;\n}\n\n.map-center-root .filter-btn {\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n}\n\n.map-center-root .filter-btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n.map-center-root .notification-badge {\n  position: absolute;\n  top: -5px;\n  /* Ajusta la posición del badge */\n  right: -5px;\n  /* Ajusta la posición del badge */\n  width: 15px;\n  /* Tamaño del badge */\n  height: 15px;\n  /* Tamaño del badge */\n  background-color: #006699;\n  /* Color del badge */\n  border-radius: 50%;\n  /* Hace que sea un círculo */\n  animation: pulse 1.5s infinite;\n  /* Hace que palpite */\n  border: 2px solid white;\n  /* Opcional: agrega un borde blanco */\n}\n\n/* Darageable infromacion adicional izq */\n.rnd-draggable {\n  cursor: move;\n}\n\n\n/* Centrar el icono del HtmlMarker */\n.map-center-root .marker-icon {\n  position: absolute;\n  width: 28px;\n  height: 28px;\n  /* sitúa el punto (0,0) del div en la coordenada: */\n  left: 50%;\n  top: 0;\n  /* desplaza el div: -50% ancho (centrado horizontal) y -100% alto \n     para que la base del icono quede clavada en la coordenada */\n  transform: translate(-50%, -100%);\n  cursor: pointer;\n  pointer-events: none;\n}\n\n.map-center-root .marker-plate-wrap {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  overflow: visible;\n}\n\n.map-center-root .hover-marker-info-button {\n  position: absolute;\n  top: auto;\n  right: auto;\n  bottom: -45px;\n  left: calc(50% + 15px);\n  z-index: 3;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  color: #ffffff;\n  font: 700 16px/1 \"Segoe UI\", sans-serif;\n  background: #0f6ea8;\n  border: 2px solid #ffffff;\n  border-radius: 50%;\n  box-shadow: 0 4px 10px rgba(15, 57, 95, 0.3);\n  cursor: pointer;\n  transition:\n    background-color 0.18s ease,\n    box-shadow 0.18s ease,\n    transform 0.18s ease;\n}\n\n.map-center-root .hover-marker-info-button:hover,\n.map-center-root .hover-marker-info-button:focus-visible {\n  color: #ffffff;\n  background: #1ca3ec;\n  box-shadow: 0 5px 13px rgba(15, 57, 95, 0.38);\n  outline: none;\n  transform: scale(1.08);\n}\n\n.map-center-root .marker-plate-badge {\n  position: absolute;\n  left: 50%;\n  top: -3px;\n  transform: translate(-50%, -100%);\n  min-width: 104px;\n  max-width: 160px;\n  padding: 5px 9px;\n  border-radius: 10px;\n  background: rgba(7, 48, 79, 0.92);\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.92);\n  box-shadow: 0 4px 10px rgba(6, 28, 47, 0.22);\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 1.25;\n  text-align: center;\n  pointer-events: none;\n}\n\n.map-center-root .marker-plate-badge__plate,\n.map-center-root .marker-plate-badge__line {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.map-center-root .marker-plate-badge__plate {\n  font-size: 11px;\n  letter-spacing: 0.04em;\n}\n\n.map-center-root .marker-plate-badge__line {\n  margin-top: 2px;\n  color: rgba(255, 255, 255, 0.88);\n  font-size: 9px;\n  font-weight: 600;\n}\n\n.map-center-root .marker-hover-anchor {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  overflow: visible;\n  transform: translate(-50%, -100%) !important;\n  outline: none;\n  cursor: pointer !important;\n  z-index: 20;\n}\n\n.map-center-root .marker-hover-anchor:hover,\n.map-center-root .marker-hover-anchor:focus-visible {\n  cursor: pointer !important;\n}\n\n.map-center-root .marker-hover-anchor .marker-icon {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer !important;\n}\n\n.map-center-root .marker-hover-anchor.is-hover-active {\n  z-index: 1400;\n}\n\n.map-center-root .info-window-hover {\n  position: absolute;\n  left: 0;\n  top: 0;\n  transform: translate(-50%, calc(-100% - 32px)) scale(0.98);\n  min-width: 220px;\n  max-width: 300px;\n  display: block;\n  visibility: hidden;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n  z-index: 1300;\n  overflow: visible;\n}\n\n.map-center-root .info-window-hover::before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  bottom: -60px;\n  width: 110px;\n  height: 60px;\n  transform: translateX(-50%);\n}\n\n.map-center-root .info-window-hover.is-visible {\n  visibility: visible;\n  opacity: 1;\n  pointer-events: auto;\n  transform: translate(-50%, calc(-100% - 42px)) scale(1);\n}\n\n.map-center-root .info-window-hover.is-hiding {\n  visibility: hidden;\n  opacity: 0;\n  pointer-events: none;\n  transform: translate(-50%, calc(-100% - 26px)) scale(0.985);\n}\n\n.map-center-root .info-window-hover-card {\n  position: relative;\n  border-radius: 14px;\n  padding: 12px 14px;\n  background: rgba(255, 255, 255, 0.98);\n  color: #284057;\n  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.2);\n  border: 1px solid rgba(0, 102, 153, 0.14);\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.map-center-root .info-window-hover-card::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  bottom: -8px;\n  width: 16px;\n  height: 16px;\n  background: rgba(255, 255, 255, 0.98);\n  border-right: 1px solid rgba(0, 102, 153, 0.14);\n  border-bottom: 1px solid rgba(0, 102, 153, 0.14);\n  transform: translateX(-50%) rotate(45deg);\n}\n\n.map-center-root .info-window-hover-title {\n  margin-bottom: 8px;\n  color: #0f3554;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.map-center-root .info-window-hover-grid {\n  display: grid;\n  gap: 4px;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #4b6175;\n}\n\n.map-center-root .info-window-hover-grid strong {\n  color: #16324a;\n}\n\n\n\n\n/* ----------------------------------\n   12) Grid de iconos en el panel de seguimiento\n   ---------------------------------- */\n/* grid y estilos básicos */\n/* contenedor general del panel de seguimiento */\n.map-center-root .icon-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  padding: 16px;\n  background: transparent;\n  /* un fondo muy suave */\n  border-radius: 12px;\n  transform: translate(-8px, 0px);\n}\n\n/* cada “casilla” de icono */\n.map-center-root .icon-grid .icon-item {\n  width: 48px;\n  height: 48px;\n  background: #FFFFFF;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  object-fit: contain;\n  filter: grayscale(100%);\n  opacity: 0.6;\n  padding: 8px;\n  /* sombra más profunda y extendida */\n  box-shadow:\n    0 4px 8px rgba(0, 0, 0, 0.1),\n    0 12px 24px rgba(0, 0, 0, 0.15);\n  transition: filter 0.3s, opacity 0.3s, transform 0.3s, box-shadow 0.3s;\n}\n\n.map-center-root .icon-grid .icon-item.active {\n  filter: none;\n  opacity: 1;\n  /* al activarse, sube un poco la sombra */\n  box-shadow:\n    0 6px 12px rgba(0, 0, 0, 0.15),\n    0 16px 32px rgba(0, 0, 0, 0.2);\n}\n\n/* íconos que cambiaron (pulso infinito) */\n.map-center-root .icon-grid .icon-item.icon-changed {\n  animation: pulse 1s ease-in-out infinite alternate;\n}\n\n/* Botones */\n.custom-offcanvas-map-center .buttonPrimary {\n  background-color: #006699 !important;\n  color: #fff !important;\n  border: none !important;\n  padding: 10px 20px !important;\n  border-radius: 5px !important;\n  cursor: pointer !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.custom-offcanvas-map-center .buttonSecondary {\n  background-color: #e0e0e0 !important;\n  color: #333 !important;\n  border: none !important;\n  padding: 10px 20px !important;\n  border-radius: 5px !important;\n  cursor: pointer !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n\n.custom-offcanvas-map-center .buttonPrimary:hover {\n  background-color: #00557a;\n}\n\n.custom-offcanvas-map-center .buttonSecondary:hover {\n  background-color: #d5d5d5;\n}\n\n.custom-offcanvas-map-center button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.custom-offcanvas-map-center .geo-actions {\n  display: flex;\n  justify-content: center;\n  /* ✅ centrado desktop */\n  gap: 10px;\n  margin-top: 12px;\n  flex-wrap: wrap;\n  /* ✅ permite salto a segunda fila */\n}\n\n/* Botones map actions*/\n\n/* =========================================================\n   Stack pegado al botón de fullscreen (Google Maps)\n   - no mueve a los otros botones\n   - solo el hovered se expande (overlay)\n   ========================================================= */\n\n/* 1) Stack cerca del fullscreen (esquina superior derecha) */\n.map-center-root .map-actions-stack {\n  position: absolute;\n  top: 60px;\n  right: 10px;\n  /* pegado al borde; si choca, sube a 14/16 */\n  z-index: 1200;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* 2) Cada fila reserva un slot fijo (no se mueve nada) */\n.map-center-root .map-actions-stack .action-item {\n  position: relative;\n  width: 40px;\n  height: 40px;\n}\n\n/* 3) El botón vive ABSOLUTO dentro del slot para expandirse sin empujar */\n.map-center-root .map-actions-stack .action-item .fast-filters-button,\n.map-center-root .map-actions-stack .action-item .fast-geocerca-button,\n.map-center-root .map-actions-stack .action-item .fast-georutas-button,\n.map-center-root .map-actions-stack .action-item .fast-invias-button,\n.map-center-root .map-actions-stack .action-item .fast-placa-button,\n.map-center-root .map-actions-stack .action-item .fast-info-button,\n.map-center-root .map-actions-stack .action-item .fast-live-button {\n  position: absolute !important;\n  top: 0;\n  right: 0;\n  /* anclado a la derecha */\n  height: 40px !important;\n  width: 20px !important;\n  min-width: 28px !important;\n\n  overflow: hidden !important;\n  border-radius: 10px !important;\n\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n\n  padding: 0 12px !important;\n  background: #fff;\n  border: 1px solid #ddd;\n\n  transition: width .18s ease, background .18s ease, border-color .18s ease;\n}\n\n/* 4) Texto oculto dentro del mismo botón */\n.map-center-root .map-actions-stack .action-item .fast-filters-button span,\n.map-center-root .map-actions-stack .action-item .fast-geocerca-button span,\n.map-center-root .map-actions-stack .action-item .fast-georutas-button span,\n.map-center-root .map-actions-stack .action-item .fast-invias-button span,\n.map-center-root .map-actions-stack .action-item .fast-placa-button span,\n.map-center-root .map-actions-stack .action-item .fast-info-button span,\n.map-center-root .map-actions-stack .action-item .fast-live-button span {\n  display: inline-block !important;\n  opacity: 0;\n  transform: translateX(-6px);\n  max-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  pointer-events: none;\n\n  font-size: 12px;\n  font-weight: 700;\n  color: #003a55;\n\n  transition: opacity .18s ease, transform .18s ease, max-width .18s ease;\n}\n\n.map-center-root .map-actions-stack .action-item .fast-devices-button {\n  position: absolute !important;\n  top: 0;\n  right: 0;\n  height: 40px !important;\n  width: 20px !important;\n  min-width: 28px !important;\n  overflow: hidden !important;\n  border-radius: 10px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  padding: 0 12px !important;\n  background: #fff;\n  color: #2e3a47;\n  border: 1px solid #ddd;\n  transition: width .18s ease, background .18s ease, border-color .18s ease;\n}\n\n.map-center-root .map-actions-stack .action-item .fast-devices-button span {\n  display: inline-block !important;\n  opacity: 0;\n  transform: translateX(-6px);\n  max-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  pointer-events: none;\n  font-size: 12px;\n  font-weight: 700;\n  color: #003a55;\n  transition: opacity .18s ease, transform .18s ease, max-width .18s ease;\n}\n\n.map-center-root .map-actions-stack .action-item .fast-filters-button svg,\n.map-center-root .map-actions-stack .action-item .fast-geocerca-button svg,\n.map-center-root .map-actions-stack .action-item .fast-georutas-button svg,\n.map-center-root .map-actions-stack .action-item .fast-invias-button svg,\n.map-center-root .map-actions-stack .action-item .fast-placa-button svg,\n.map-center-root .map-actions-stack .action-item .fast-devices-button svg,\n.map-center-root .map-actions-stack .action-item .fast-info-button svg,\n.map-center-root .map-actions-stack .action-item .fast-live-button svg {\n  flex-shrink: 0;\n}\n\n.map-center-root .map-actions-stack .action-item .fast-live-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #dc3545;\n  box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);\n  animation: info-window-pulse 1.2s ease-out infinite;\n  flex: none;\n}\n\n.map-center-root .map-actions-stack .action-item:hover .fast-devices-button,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-devices-button {\n  width: 160px !important;\n  justify-content: flex-start !important;\n  border-color: rgba(0, 102, 153, .35);\n  background: rgba(255, 255, 255, .95);\n}\n\n.map-center-root .map-actions-stack .action-item:hover .fast-devices-button span,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-devices-button span {\n  opacity: 1;\n  transform: translateX(0);\n  max-width: 120px;\n}\n\n.map-center-root .map-actions-stack .action-item .fast-devices-button.active {\n  background: #006699;\n  border-color: #006699;\n  color: #fff;\n}\n\n.map-center-root .map-actions-stack .action-item .fast-devices-button.active span {\n  color: #fff;\n}\n\n/* 5) SOLO el hovered se expande hacia la izquierda (overlay) */\n.map-center-root .map-actions-stack .action-item:hover .fast-filters-button,\n.map-center-root .map-actions-stack .action-item:hover .fast-geocerca-button,\n.map-center-root .map-actions-stack .action-item:hover .fast-georutas-button,\n.map-center-root .map-actions-stack .action-item:hover .fast-invias-button,\n.map-center-root .map-actions-stack .action-item:hover .fast-placa-button,\n.map-center-root .map-actions-stack .action-item:hover .fast-info-button,\n.map-center-root .map-actions-stack .action-item:hover .fast-live-button,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-filters-button,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-geocerca-button,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-georutas-button,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-invias-button,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-placa-button,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-info-button,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-live-button {\n  width: 160px !important;\n  /* ancho del pill */\n  justify-content: flex-start !important;\n  border-color: rgba(0, 102, 153, .35);\n  background: rgba(255, 255, 255, .95);\n  color: #2e3a47 !important;\n}\n\n/* 6) Mostrar texto del hovered */\n.map-center-root .map-actions-stack .action-item:hover .fast-filters-button span,\n.map-center-root .map-actions-stack .action-item:hover .fast-geocerca-button span,\n.map-center-root .map-actions-stack .action-item:hover .fast-georutas-button span,\n.map-center-root .map-actions-stack .action-item:hover .fast-invias-button span,\n.map-center-root .map-actions-stack .action-item:hover .fast-placa-button span,\n.map-center-root .map-actions-stack .action-item:hover .fast-info-button span,\n.map-center-root .map-actions-stack .action-item:hover .fast-live-button span,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-filters-button span,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-geocerca-button span,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-georutas-button span,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-invias-button span,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-placa-button span,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-info-button span,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-live-button span {\n  opacity: 1;\n  transform: translateX(0);\n  max-width: 120px;\n}\n\n/* 7) Active */\n.map-center-root .map-actions-stack .action-item .fast-filters-button.active,\n.map-center-root .map-actions-stack .action-item .fast-geocerca-button.active,\n.map-center-root .map-actions-stack .action-item .fast-georutas-button.active,\n.map-center-root .map-actions-stack .action-item .fast-invias-button.active,\n.map-center-root .map-actions-stack .action-item .fast-placa-button.active,\n.map-center-root .map-actions-stack .action-item .fast-info-button.active,\n.map-center-root .map-actions-stack .action-item .fast-live-button.active {\n  background: #006699;\n  border-color: #006699;\n  color: #fff;\n}\n\n.map-center-root .map-actions-stack .action-item .fast-filters-button.active span,\n.map-center-root .map-actions-stack .action-item .fast-geocerca-button.active span,\n.map-center-root .map-actions-stack .action-item .fast-georutas-button.active span,\n.map-center-root .map-actions-stack .action-item .fast-invias-button.active span,\n.map-center-root .map-actions-stack .action-item .fast-placa-button.active span,\n.map-center-root .map-actions-stack .action-item .fast-info-button.active span,\n.map-center-root .map-actions-stack .action-item .fast-live-button.active span {\n  color: #fff;\n}\n\n\n\n\n\n\n\n.map-center-root .map-actions-stack .action-btn {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  color: #2e3a47;\n  border: 1px solid #ddd;\n}\n\n.map-center-root .map-actions-stack .action-btn.active {\n  background: #006699;\n  color: #fff;\n  border-color: #006699;\n}\n\n.map-center-root .map-actions-stack .action-btn:hover {\n  background: #e9f2f8;\n}\n\n\n\n/* Colapsa la lista */\n.right-dropdown-menu .device-cards.is-collapsed {\n  display: none;\n  min-height: auto;\n}\n\n.left-dropdown-menu .device-cards.is-collapsed {\n  display: none;\n  min-height: 5px;\n}\n\n/* Pestaña tipo acordeón (flecha) */\n.right-dropdown-menu {\n  position: relative;\n  /* para posicionar la pestaña dentro */\n}\n\n.left-dropdown-menu {\n  position: relative;\n  /* para posicionar la pestaña dentro */\n}\n\n/* Tab translucida */\n.devices-toggle-tab {\n  position: sticky;\n  /* se queda abajo aunque scrollees */\n  bottom: 0;\n  width: 140px;\n  height: 34px;\n  border: 0;\n  cursor: pointer;\n  margin: 0 auto;\n  border-radius: 12px 12px 0 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n\n  background: rgba(0, 102, 153, 0.22);\n  /* translúcido */\n  backdrop-filter: blur(6px);\n  /* glass effect */\n  -webkit-backdrop-filter: blur(6px);\n\n  color: #003a55;\n  transition: background .15s ease, transform .15s ease, opacity .15s ease;\n  opacity: .65;\n}\n\n/* Hover: más visible y clickeable */\n.devices-toggle-tab:hover {\n  background: rgba(0, 102, 153, 0.45);\n  opacity: 1;\n}\n\n/* Flecha grande */\n.devices-toggle-tab .tab-arrow {\n  font-size: 18px;\n  line-height: 1;\n  font-weight: 700;\n  color: #003a55;\n}\n\n/* Cuando está cerrado, muestro contador al lado */\n.devices-toggle-tab .tab-count {\n  min-width: 28px;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 999px;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 12px;\n  font-weight: 700;\n\n  background: rgba(255, 255, 255, .8);\n  color: #003a55;\n  border: 1px solid rgba(0, 58, 85, .25);\n}\n\n/* Pequeño “feedback” visual según estado */\n.devices-toggle-tab.is-open .tab-arrow {\n  transform: translateY(1px);\n}\n\n.devices-toggle-tab.is-closed .tab-arrow {\n  transform: translateY(-1px);\n}\n\n\n\n/* keyframes del pulso */\n@keyframes pulse {\n  from {\n    transform: scale(1);\n  }\n\n  to {\n    transform: scale(1.15);\n  }\n}\n\n/* Cards de dispositivos con la misma jerarquia visual en desktop y responsive. */\n.map-center-root .device-card.device-card--responsive {\n  width: 100% !important;\n  margin-bottom: 10px !important;\n  border: 1px solid rgba(110, 144, 176, 0.16) !important;\n  border-left: 5px solid var(--device-status-color) !important;\n  border-radius: 0 16px 16px 0 !important;\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 7px 18px rgba(17, 48, 79, 0.14);\n  overflow: hidden;\n  transform: none;\n}\n\n.map-center-root .device-card.device-card--responsive:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 22px rgba(17, 48, 79, 0.2);\n}\n\n.map-center-root .device-card__body {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-height: 220px;\n  padding: 12px 12px 10px !important;\n  color: #4d6984;\n}\n\n.map-center-root .device-card__header {\n  position: relative;\n  display: grid;\n  grid-template-columns: 38px minmax(0, 1fr);\n  align-items: center;\n  gap: 7px;\n  min-width: 0;\n  min-height: 38px;\n  padding-right: 26px;\n}\n\n.map-center-root .device-card__vehicle-icon {\n  width: 38px;\n  height: 38px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  background: rgba(22, 119, 210, 0.12);\n  color: var(--device-status-color);\n  font-size: 18px;\n}\n\n.map-center-root .device-card__heading {\n  min-width: 0;\n}\n\n.map-center-root .device-card__company {\n  overflow: hidden;\n  color: #152b47;\n  font-size: 0.82rem;\n  font-weight: 800;\n  line-height: 1.15;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.map-center-root .device-card__identity {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 6px;\n}\n\n.map-center-root .device-card__pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  max-width: 100%;\n  padding: 5px 7px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #eef4fa;\n  color: #526c86;\n  font-size: 0.62rem;\n  line-height: 1;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.map-center-root .device-card__pill svg {\n  flex: 0 0 auto;\n  color: #4d6984;\n}\n\n.map-center-root .device-card__chevron,\n.map-center-root .device-card__more {\n  color: #58738e;\n  font-size: 0.85rem;\n}\n\n.map-center-root .device-card__chevron {\n  position: absolute;\n  top: 1px;\n  right: -4px;\n  font-size: 1.35rem;\n}\n\n.map-center-root .device-card__more {\n  font-size: 0.95rem;\n}\n\n.map-center-root .device-card__location {\n  display: flex;\n  align-items: flex-start;\n  gap: 7px;\n  margin-top: 11px;\n  min-height: 2.6em;\n  color: #516c87;\n  font-size: 0.72rem;\n  line-height: 1.3;\n}\n\n.map-center-root .device-card__location > span {\n  min-width: 0;\n  display: -webkit-box;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n\n.map-center-root .device-card__location svg {\n  flex: 0 0 auto;\n  margin-top: 1px;\n  color: #536f8b;\n  font-size: 0.95rem;\n}\n\n.map-center-root .device-card__location strong {\n  color: #304c68;\n  font-weight: 800;\n}\n\n.map-center-root .device-card__device-location {\n  min-height: 1.3em;\n}\n\n.map-center-root .device-card__metrics {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 14px;\n  margin-top: 8px;\n  min-height: 18px;\n  padding-left: 0;\n  color: #536f8b;\n  font-size: 0.72rem;\n}\n\n.map-center-root .device-card__metrics span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-weight: 700;\n}\n\n.map-center-root .device-card__metrics span:last-child {\n  color: #536f8b;\n}\n\n.map-center-root .device-card__metrics svg {\n  font-size: 0.9rem;\n}\n\n.map-center-root .device-card__footer {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto 48px;\n  align-items: center;\n  gap: 6px;\n  min-height: 32px;\n  margin-top: auto;\n  padding-top: 9px;\n  border-top: 1px solid #e2eaf1;\n}\n\n.map-center-root .device-card__status-icons {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n}\n\n.map-center-root .device-card__status-icons img {\n  width: 19px;\n  height: 19px;\n  object-fit: contain;\n}\n\n.map-center-root .device-card__state {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 8px;\n  min-width: 88px;\n  justify-content: center;\n  border-radius: 999px;\n  font-size: 0.64rem;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.map-center-root .device-card__state-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.map-center-root .device-card__state--moving {\n  color: #129447;\n  background: #def8e9;\n}\n\n.map-center-root .device-card__state--stopped {\n  color: #e5233b;\n  background: #ffe1e6;\n}\n\n.map-center-root .device-card__state--review {\n  color: #1677d2;\n  background: #dceeff;\n}\n\n.map-center-root .device-card__time {\n  width: 48px;\n  text-align: right;\n  color: #71869b;\n  font-size: 0.65rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n@media (max-width: 768px) {\n  .offcanvas-backdrop.show {\n    left: 0 !important;\n    width: 100vw !important;\n    right: 0 !important;\n    z-index: 2999 !important;\n  }\n\n  .offcanvas.custom-offcanvas-map-center {\n    left: 0 !important;\n    right: 0 !important;\n    margin-left: 0 !important;\n    width: 100vw !important;\n    max-width: 100vw !important;\n    z-index: 3000 !important;\n  }\n\n  .map-center-root .alerts-row {\n    /* posición */\n    width: 300px;\n    height: 120px;\n    top: 110px;\n    /* debajo de tus botones */\n    right: 20px;\n    left: auto;\n    transform: none;\n\n    /* 2 filas fijas */\n    display: grid !important;\n    grid-auto-flow: column;\n    /* llena columnas y baja a la fila 2 */\n    grid-template-rows: repeat(2, auto);\n    grid-auto-columns: max-content;\n\n    gap: 8px;\n    align-items: center;\n    justify-content: center;\n\n    /* que NO se meta bajo el sidenav */\n    max-width: calc(100vw - 64px - 20px);\n    overflow-x: auto;\n    /* si hay muchos, scrol horizontal */\n    padding-bottom: 2px;\n\n    z-index: 1200;\n  }\n\n  .map-center-root .alert-icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 9px;\n    position: relative;\n  }\n\n  .map-center-root .alert-icon img {\n    width: 22px;\n    height: 22px;\n    object-fit: contain;\n  }\n\n  .map-center-root .badge.badge-count {\n    font-size: .68rem;\n  }\n\n  /* opcional: barra de scroll más discreta (Chrome/Edge) */\n  .map-center-root .alerts-row::-webkit-scrollbar {\n    height: 6px;\n  }\n\n  /* el panel existe, pero el contenido se colapsa */\n  .map-center-root .right-dropdown-menu {\n    min-height: unset;\n    /* quita esos 420px en mobile */\n    height: auto;\n    overflow: hidden;\n  }\n\n  .map-center-root .left-dropdown-menu {\n    min-height: unset;\n    left: 8px;\n    width: min(92vw, 360px);\n    /* quita esos 420px en mobile */\n    height: 55vh;\n    overflow: hidden;\n  }\n\n  .map-center-root .left-dropdown-menu.is-collapsed{\n    height: auto;\n  }\n\n\n\n\n\n  /* animación del contenedor de cards */\n  .map-center-root .device-cards {\n    max-height: 520px;\n    /* abierto */\n    overflow-y: auto;\n    transition: max-height 250ms ease, opacity 200ms ease, transform 200ms ease;\n    transform-origin: top;\n    opacity: 1;\n    transform: translateY(0);\n    width: 80vw;\n  }\n\n  /* estado colapsado: queda solo el botón visible */\n  .map-center-root .device-cards.is-collapsed {\n    max-height: 0;\n    overflow: hidden;\n    opacity: 0;\n    transform: translateY(-6px);\n    pointer-events: none;\n    display: none;\n  }\n\n  .custom-offcanvas-map-center .geo-actions {\n    gap: 8px;\n  }\n\n  .custom-offcanvas-map-center .geo-actions>button {\n    width: calc(50% - 4px);\n    /* ✅ 2 por fila */\n    min-width: 140px;\n    /* opcional */\n  }\n\n  /* ================================\n   MAP ACTIONS STACK (MOBILE FIXED)\n   - NO hover expand\n   - NO span\n   - NO shift al activar (.active)\n   - ancho fijo 40x40\n   ================================ */\n\n  /* stack horizontal */\n  .map-center-root .map-actions-stack {\n    position: absolute;\n    top: 10px;\n    right: 60px;\n    z-index: 1200;\n\n    display: flex;\n    flex-direction: row;\n    gap: 34px;\n\n    align-items: center;\n    justify-content: flex-start;\n\n    max-width: calc(100vw - 120px);\n  }\n\n  .map-center-root .map-actions-stack,\n  .map-center-root .map-actions-stack *,\n  .map-center-root .map-actions-stack *::before,\n  .map-center-root .map-actions-stack *::after {\n    transition: none !important;\n    animation: none !important;\n  }\n\n  /* evita cualquier “hover expand” heredado */\n  .map-center-root .map-actions-stack .action-item:hover .fast-filters-button,\n  .map-center-root .map-actions-stack .action-item:hover .fast-geocerca-button,\n  .map-center-root .map-actions-stack .action-item:hover .fast-georutas-button,\n  .map-center-root .map-actions-stack .action-item:hover .fast-invias-button,\n  .map-center-root .map-actions-stack .action-item:hover .fast-live-button,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-filters-button,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-geocerca-button,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-georutas-button,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-invias-button,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-live-button {\n    width: 40px !important;\n    justify-content: center !important;\n  }\n\n  /* si no quieres el puntico “pulse” en mobile, apágalo */\n  .map-center-root .fast-filters-button.active::after,\n  .map-center-root .fast-geocerca-button.active::after,\n  .map-center-root .fast-georutas-button.active::after,\n  .map-center-root .fast-invias-button.active::after,\n  .map-center-root .fast-live-button.active::after {\n    animation: none !important;\n    transform: none !important;\n    transition: none !important;\n  }\n\n  .map-center-root .map-actions-stack .btn.fast-filters-button span,\n  .map-center-root .map-actions-stack .btn.fast-geocerca-button span,\n  .map-center-root .map-actions-stack .btn.fast-georutas-button span,\n  .map-center-root .map-actions-stack .btn.fast-invias-button span,\n  .map-center-root .map-actions-stack .btn.fast-live-button span {\n    display: none !important;\n  }\n\n\n  .map-center-root .search-input {\n    width: 100%;\n    max-width: none;\n    height: 54px;\n    padding: 0 18px;\n    border: 1px solid rgba(112, 145, 177, 0.22);\n    border-radius: 18px;\n    background: rgba(255, 255, 255, 0.96);\n    color: #24415d;\n    font-size: 0.98rem;\n    box-shadow: 0 10px 24px rgba(18, 52, 82, 0.16);\n  }\n\n  .map-center-root .search-input::placeholder {\n    color: #8aa0b6;\n    opacity: 1;\n  }\n\n  .map-center-root .search-filter-container {\n    top: 70px;\n    left: 14px;\n    right: 14px !important;\n    gap: 10px;\n    z-index: 1203;\n  }\n\n  .map-center-root .filter-btn {\n    width: 54px;\n    height: 54px;\n    border: 1px solid rgba(84, 118, 151, 0.35);\n    border-radius: 18px;\n    background: rgba(255, 255, 255, 0.96);\n    color: #294968;\n    box-shadow: 0 10px 24px rgba(18, 52, 82, 0.16);\n  }\n\n  .map-center-root .filter-btn:hover,\n  .map-center-root .filter-btn:focus {\n    background: #ffffff;\n    color: #0b72bd;\n    border-color: #6da7d8;\n  }\n\n  .map-center-root .left-dropdown-menu {\n    top: 138px !important;\n    left: 14px;\n    width: min(calc(100vw - 28px), 430px);\n    height: calc(100% - 152px);\n    max-height: none;\n    border-radius: 22px;\n    overflow: hidden;\n    pointer-events: none;\n  }\n\n  .map-center-root .left-dropdown-menu .device-cards,\n  .map-center-root .left-dropdown-menu .devices-toggle-tab {\n    pointer-events: auto;\n  }\n\n  .map-center-root .device-cards {\n    width: 100%;\n    max-height: 100%;\n    padding: 0 0 10px;\n  }\n\n  .map-center-root .device-card.device-card--responsive {\n    width: 100% !important;\n    margin-bottom: 12px !important;\n    border: 1px solid rgba(110, 144, 176, 0.14) !important;\n    border-left: 6px solid var(--device-status-color) !important;\n    border-radius: 0 20px 20px 0 !important;\n    background: rgba(255, 255, 255, 0.98);\n    box-shadow: 0 10px 26px rgba(17, 48, 79, 0.17);\n    overflow: hidden;\n    transform: none;\n  }\n\n  .map-center-root .device-card.device-card--responsive:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 14px 30px rgba(17, 48, 79, 0.21);\n  }\n\n  .map-center-root .device-card__body {\n    min-height: 288px;\n    padding: 16px 16px 13px !important;\n    color: #4d6984;\n  }\n\n  .map-center-root .device-card__header {\n    position: relative;\n    display: grid;\n    grid-template-columns: 52px minmax(0, 1fr);\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n    min-height: 52px;\n    padding-right: 30px;\n  }\n\n  .map-center-root .device-card__vehicle-icon {\n    width: 52px;\n    height: 52px;\n    display: grid;\n    place-items: center;\n    border-radius: 50%;\n    background: color-mix(in srgb, var(--device-status-color) 14%, white);\n    color: var(--device-status-color);\n    font-size: 25px;\n  }\n\n  .map-center-root .device-card__heading {\n    min-width: 0;\n  }\n\n  .map-center-root .device-card__company {\n    overflow: hidden;\n    color: #152b47;\n    font-size: 1.02rem;\n    font-weight: 800;\n    line-height: 1.15;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .map-center-root .device-card__identity {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-top: 8px;\n  }\n\n  .map-center-root .device-card__pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    max-width: 100%;\n    padding: 6px 9px;\n    overflow: hidden;\n    border-radius: 999px;\n    background: #eef4fa;\n    color: #526c86;\n    font-size: 0.75rem;\n    line-height: 1;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .map-center-root .device-card__pill svg {\n    flex: 0 0 auto;\n    color: #4d6984;\n  }\n\n  .map-center-root .device-card__chevron,\n  .map-center-root .device-card__more {\n    color: #58738e;\n    font-size: 1rem;\n  }\n\n  .map-center-root .device-card__chevron {\n    position: absolute;\n    top: 1px;\n    right: -4px;\n    font-size: 1.5rem;\n  }\n\n  .map-center-root .device-card__more {\n    font-size: 1.05rem;\n  }\n\n  .map-center-root .device-card__location {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    margin-top: 15px;\n    min-height: 2.7em;\n    color: #516c87;\n    font-size: 0.86rem;\n    line-height: 1.35;\n  }\n\n  .map-center-root .device-card__location > span {\n    min-width: 0;\n    display: -webkit-box;\n    overflow: hidden;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n  }\n\n  .map-center-root .device-card__location svg {\n    flex: 0 0 auto;\n    margin-top: 2px;\n    color: #536f8b;\n    font-size: 1.1rem;\n  }\n\n  .map-center-root .device-card__location strong {\n    color: #304c68;\n    font-weight: 800;\n  }\n\n  .map-center-root .device-card__device-location {\n    min-height: 1.3em;\n  }\n\n  .map-center-root .device-card__metrics {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 20px;\n    margin-top: 11px;\n    min-height: 22px;\n    padding-left: 0;\n    color: #536f8b;\n    font-size: 0.87rem;\n  }\n\n  .map-center-root .device-card__metrics span {\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n    font-weight: 700;\n  }\n\n  .map-center-root .device-card__metrics span:last-child {\n    color: #536f8b;\n  }\n\n  .map-center-root .device-card__metrics svg {\n    font-size: 1.06rem;\n  }\n\n  .map-center-root .device-card__footer {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto 52px;\n    align-items: center;\n    gap: 8px;\n    min-height: 38px;\n    margin-top: auto;\n    padding-top: 12px;\n    border-top: 1px solid #e2eaf1;\n  }\n\n  .map-center-root .device-card__status-icons {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n  }\n\n  .map-center-root .device-card__status-icons img {\n    width: 23px;\n    height: 23px;\n    object-fit: contain;\n  }\n\n  .map-center-root .device-card__state {\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n    padding: 7px 10px;\n    min-width: 100px;\n    justify-content: center;\n    border-radius: 999px;\n    font-size: 0.75rem;\n    font-weight: 800;\n    white-space: nowrap;\n  }\n\n  .map-center-root .device-card__state-dot {\n    width: 9px;\n    height: 9px;\n    border-radius: 50%;\n    background: currentColor;\n  }\n\n  .map-center-root .device-card__state--moving {\n    color: #129447;\n    background: #def8e9;\n  }\n\n  .map-center-root .device-card__state--stopped {\n    color: #e5233b;\n    background: #ffe1e6;\n  }\n\n  .map-center-root .device-card__state--review {\n    color: #1677d2;\n    background: #dceeff;\n  }\n\n  .map-center-root .device-card__time {\n    width: 52px;\n    text-align: right;\n    color: #71869b;\n    font-size: 0.76rem;\n    font-weight: 700;\n    white-space: nowrap;\n  }\n}\n\n/* Devices grid toggle button */\n.map-center-root .fast-devices-button {\n  position: absolute;\n  top: 148px;\n  /* debajo de georutas */\n  right: 57px;\n  z-index: 1000;\n  width: 124px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10px;\n}\n\n.map-center-root .fast-devices-button.active::after {\n  content: \"\";\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 8px;\n  height: 8px;\n  background: #006699;\n  border-radius: 50%;\n  animation: pulse 1.5s infinite ease-in-out;\n}\n\n/* Map actions stack rules for devices button */\n.map-center-root .map-actions-stack .action-item .fast-devices-button {\n  position: absolute !important;\n  top: 0;\n  right: 0;\n  height: 40px !important;\n  width: 20px !important;\n  min-width: 28px !important;\n  overflow: hidden !important;\n  border-radius: 10px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  padding: 0 12px !important;\n  background: #fff;\n  border: 1px solid #ddd;\n  transition: width .18s ease, background .18s ease, border-color .18s ease;\n}\n\n.map-center-root .map-actions-stack .action-item .fast-devices-button span {\n  display: inline-block !important;\n  opacity: 0;\n  transform: translateX(-6px);\n  max-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  pointer-events: none;\n  font-size: 12px;\n  font-weight: 700;\n  color: #003a55;\n  transition: opacity .18s ease, transform .18s ease, max-width .18s ease;\n}\n\n.map-center-root .map-actions-stack .action-item:hover .fast-devices-button,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-devices-button {\n  width: 160px !important;\n  justify-content: flex-start !important;\n  border-color: rgba(0, 102, 153, .35);\n  background: rgba(255, 255, 255, .95);\n}\n\n.map-center-root .map-actions-stack .action-item:hover .fast-devices-button span,\n.map-center-root .map-actions-stack .action-item:focus-within .fast-devices-button span {\n  opacity: 1;\n  transform: translateX(0);\n  max-width: 120px;\n}\n\n.map-center-root .map-actions-stack .action-item .fast-devices-button.active {\n  background: #006699;\n  border-color: #006699;\n  color: #fff;\n}\n\n.map-center-root .map-actions-stack .action-item .fast-devices-button.active span {\n  color: #fff;\n}\n\n@media (max-width: 768px) {\n  .map-center-root .map-actions-stack .action-item:nth-child(-n+3) {\n    display: none !important;\n  }\n\n  /**\n   * Hides the last three action items in the map actions stack\n   * \n   * This rule targets the last 3 child elements (counting from the end)\n   * within the action-item class and removes them from the document flow\n   * by setting their display property to none with high specificity.\n   * \n   * Selector breakdown:\n   * - .map-center-root: Root container for map-related styles\n   * - .map-actions-stack: Container holding action items\n   * - .action-item:nth-last-child(-n+3): Matches the last 3 action items\n   * \n   * @note !important flag ensures this rule overrides any competing styles\n   */\n  .map-center-root .map-actions-stack .action-item:nth-child(n+5) {\n    display: none !important;\n  }\n\n  .map-center-root .map-actions-stack .action-item:hover .fast-devices-button,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-devices-button {\n    width: 40px !important;\n    justify-content: center !important;\n  }\n\n  .map-center-root .fast-devices-button.active::after {\n    animation: none !important;\n    transform: none !important;\n    transition: none !important;\n  }\n\n  .map-center-root .map-actions-stack .btn.fast-devices-button span {\n    display: none !important;\n  }\n\n  .map-center-root .map-fullscreen-control {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .map-center-root .map-actions-dropdown {\n    position: relative;\n  }\n\n  .map-center-root .map-actions-dropdown-toggle {\n    width: 40px;\n    height: 40px;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .map-center-root .map-actions-dropdown-toggle.is-active {\n    background: linear-gradient(135deg, #0f6ea8, #1ca3ec);\n    border-color: transparent;\n    color: #fff;\n    box-shadow: 0 10px 24px rgba(24, 119, 179, 0.22);\n  }\n\n  .map-center-root .map-actions-dropdown-menu {\n    position: absolute;\n    top: 48px;\n    right: 0;\n    min-width: 200px;\n    background: #fff;\n    border: 1px solid #dce6f2;\n    border-radius: 10px;\n    box-shadow: 0 16px 30px rgba(2, 20, 45, 0.15);\n    padding: 6px;\n    z-index: 1300;\n  }\n\n  .map-center-root .map-actions-dropdown-item {\n    width: 100%;\n    border: 0;\n    background: transparent;\n    padding: 8px 10px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    border-radius: 8px;\n    color: #003a55;\n    font-weight: 600;\n  }\n\n  .map-center-root .map-actions-dropdown-item.is-active {\n    background: #eaf5ff;\n    color: #0f6ea8;\n    box-shadow: inset 3px 0 0 #1ca3ec;\n  }\n\n  .map-center-root .map-actions-dropdown-item:hover,\n  .map-center-root .map-actions-dropdown-item:focus {\n    background: #f2f7fb;\n  }\n\n  .map-center-root .map-actions-dropdown-item-wrap {\n    display: flex;\n  }\n\n}\n\n/* Estructura estable: el contenido puede truncarse, pero no cambia la geometría de la card. */\n.map-center-root .device-card.device-card--responsive {\n  height: 195px !important;\n  min-height: 195px !important;\n  display: block !important;\n  width: 100% !important;\n}\n\n.map-center-root .device-card.device-card--responsive .device-card__body {\n  height: 100%;\n  width: 100%;\n  min-height: 0 !important;\n  overflow: hidden;\n}\n\n.map-center-root .device-card__identity {\n  flex-wrap: nowrap;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.map-center-root .device-card__identity .device-card__pill {\n  min-width: 0;\n  flex: 0 1 auto;\n  width: fit-content;\n  max-width: 100%;\n}\n\n.map-center-root .device-card__location {\n  flex: 0 0 auto;\n}\n\n@media (max-width: 768px) {\n  .map-center-root .device-card.device-card--responsive {\n    height: 240px !important;\n    min-height: 240px !important;\n  }\n}\n\n/* Controles desktop: tamaño visual de la referencia + expansión original al hacer hover. */\n@media (min-width: 769px) {\n  .map-center-root .map-actions-stack .action-item {\n    width: 40px;\n    height: 40px;\n  }\n\n  .map-center-root .map-actions-stack .action-item .fast-filters-button,\n  .map-center-root .map-actions-stack .action-item .fast-geocerca-button,\n  .map-center-root .map-actions-stack .action-item .fast-georutas-button,\n  .map-center-root .map-actions-stack .action-item .fast-invias-button,\n  .map-center-root .map-actions-stack .action-item .fast-placa-button,\n  .map-center-root .map-actions-stack .action-item .fast-devices-button,\n  .map-center-root .map-actions-stack .action-item .fast-info-button,\n  .map-center-root .map-actions-stack .action-item .fast-live-button {\n    width: 40px !important;\n    min-width: 40px !important;\n    height: 40px !important;\n    padding: 4px 0 4px 12px !important;\n    border-radius: 8px !important;\n    box-shadow: 0 5px 12px rgba(24, 50, 74, 0.12);\n  }\n\n  .map-center-root .map-actions-stack .action-item .fast-filters-button svg,\n  .map-center-root .map-actions-stack .action-item .fast-geocerca-button svg,\n  .map-center-root .map-actions-stack .action-item .fast-georutas-button svg,\n  .map-center-root .map-actions-stack .action-item .fast-invias-button svg,\n  .map-center-root .map-actions-stack .action-item .fast-placa-button svg,\n  .map-center-root .map-actions-stack .action-item .fast-devices-button svg,\n  .map-center-root .map-actions-stack .action-item .fast-info-button svg,\n  .map-center-root .map-actions-stack .action-item .fast-live-button svg {\n    width: 24px;\n    height: 24px;\n  }\n\n  .map-center-root .map-actions-stack .action-item:hover .fast-filters-button,\n  .map-center-root .map-actions-stack .action-item:hover .fast-geocerca-button,\n  .map-center-root .map-actions-stack .action-item:hover .fast-georutas-button,\n  .map-center-root .map-actions-stack .action-item:hover .fast-invias-button,\n  .map-center-root .map-actions-stack .action-item:hover .fast-placa-button,\n  .map-center-root .map-actions-stack .action-item:hover .fast-devices-button,\n  .map-center-root .map-actions-stack .action-item:hover .fast-info-button,\n  .map-center-root .map-actions-stack .action-item:hover .fast-live-button,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-filters-button,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-geocerca-button,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-georutas-button,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-invias-button,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-placa-button,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-devices-button,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-info-button,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-live-button {\n    width: 160px !important;\n    min-width: 160px !important;\n    justify-content: flex-start !important;\n  }\n\n  .map-center-root .map-actions-stack .action-item:hover .fast-filters-button span,\n  .map-center-root .map-actions-stack .action-item:hover .fast-geocerca-button span,\n  .map-center-root .map-actions-stack .action-item:hover .fast-georutas-button span,\n  .map-center-root .map-actions-stack .action-item:hover .fast-invias-button span,\n  .map-center-root .map-actions-stack .action-item:hover .fast-placa-button span,\n  .map-center-root .map-actions-stack .action-item:hover .fast-devices-button span,\n  .map-center-root .map-actions-stack .action-item:hover .fast-info-button span,\n  .map-center-root .map-actions-stack .action-item:hover .fast-live-button span,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-filters-button span,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-geocerca-button span,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-georutas-button span,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-invias-button span,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-placa-button span,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-devices-button span,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-info-button span,\n  .map-center-root .map-actions-stack .action-item:focus-within .fast-live-button span {\n    opacity: 1;\n    transform: translateX(0);\n    max-width: 120px;\n  }\n}\n\n/* El ID del dispositivo se revela sin cambiar el ancho ni la estructura de la card. */\n.map-center-root .device-card__identity {\n  overflow: visible;\n}\n\n.map-center-root .device-card__pill--device-id {\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.map-center-root .device-card__pill--device-id .device-card__pill-value {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.map-center-root .device-card__pill--device-id::after {\n  content: attr(data-value);\n  position: absolute;\n  top: 50%;\n  left: 30px;\n  max-width: 0;\n  overflow: hidden;\n  padding: 0;\n  border-radius: 999px;\n  background: #eef4fa;\n  color: #526c86;\n  opacity: 0;\n  transform: translateY(-50%);\n  white-space: nowrap;\n  pointer-events: none;\n  transition: max-width 0.35s ease, opacity 0.2s ease, padding 0.35s ease;\n}\n\n@media (hover: hover) {\n  .map-center-root .device-card__pill--device-id:hover,\n  .map-center-root .device-card__pill--device-id:focus-within {\n    overflow: visible;\n    z-index: 20;\n  }\n\n  .map-center-root .device-card__pill--device-id:hover .device-card__pill-value,\n  .map-center-root .device-card__pill--device-id:focus-within .device-card__pill-value {\n    color: transparent;\n  }\n\n  .map-center-root .device-card__pill--device-id:hover::after,\n  .map-center-root .device-card__pill--device-id:focus-within::after {\n    max-width: 260px;\n    padding-right: 10px;\n    opacity: 1;\n  }\n}\n\n/* El ID se desplaza dentro del pill, sin expandirlo ni salir de sus límites. */\n.map-center-root .device-card__pill--device-id {\n  overflow: hidden !important;\n}\n\n.map-center-root .device-card__pill--device-id::after {\n  display: none;\n}\n\n.map-center-root .device-card__pill--device-id .device-card__pill-value {\n  display: inline-block;\n  flex: 0 0 auto;\n  max-width: none;\n  overflow: visible;\n  text-overflow: clip;\n  color: #526c86;\n  white-space: nowrap;\n}\n\n@keyframes device-id-pan-inside-pill {\n  0%,\n  20% {\n    transform: translateX(0);\n  }\n\n  80%,\n  100% {\n    transform: translateX(-32%);\n  }\n}\n\n@media (hover: hover) {\n  .map-center-root .device-card__pill--device-id:hover .device-card__pill-value,\n  .map-center-root .device-card__pill--device-id:focus-within .device-card__pill-value {\n    animation: device-id-pan-inside-pill 3.8s ease-in-out infinite alternate;\n    color: #526c86;\n  }\n}\n\n.map-center-root .device-card__pill-value-viewport {\n  display: block;\n  min-width: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n/* Identificadores legibles en las cards de dispositivos, sin aumentar el ancho de la card. */\n.map-center-root .device-card__pill {\n  padding: 6px 9px;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n.map-center-root .device-card__pill svg {\n  font-size: 0.9rem;\n}\n\n.map-center-root .bottom-device-card__device,\n.map-center-root .bottom-device-card__plate,\n.map-center-root .bottom-device-table__device,\n.map-center-root .bottom-device-table__plate {\n  color: #14324a;\n  font-size: 1rem;\n  font-weight: 800;\n}\n\n.map-center-root .info-window-hover-device {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n@media (max-width: 768px) {\n  .map-center-root .device-card__pill {\n    padding: 7px 10px;\n    font-size: 0.9rem;\n  }\n\n  .map-center-root .device-card__pill svg {\n    font-size: 1rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
